import * as i0 from '@angular/core';
import { EventEmitter, forwardRef, HostListener, Output, Input, HostBinding, Component, ViewEncapsulation, ViewChild, ChangeDetectionStrategy, Self, Optional, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { SliderModule } from 'primeng/slider';
import * as i4 from '@watchguard/wg-ng-core';
import { WgSelectButtonModule, WgIconModule, WgServicesModule, WgDropdownModule } from '@watchguard/wg-ng-core';
import moment from 'moment';
import { DomHandler } from 'primeng/dom';
function DateInputComponent_tr_35_td_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 3);
    i0.ɵɵlistener("click", function DateInputComponent_tr_35_td_1_Template_td_click_0_listener($event) {
      const day_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.calendarDayClick($event, day_r2));
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const day_r2 = ctx.$implicit;
    i0.ɵɵclassProp("active", day_r2.active)("disabled", day_r2.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(day_r2.label);
  }
}
function DateInputComponent_tr_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, DateInputComponent_tr_35_td_1_Template, 3, 5, "td", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const calendarWeek_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", calendarWeek_r4.days);
  }
}
function DateInputComponent_footer_36_ng_container_7_b_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const shortcut_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, shortcut_r6.typeLabel));
  }
}
function DateInputComponent_footer_36_ng_container_7_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const shortcut_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, shortcut_r6.typeLabel));
  }
}
function DateInputComponent_footer_36_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 12);
    i0.ɵɵlistener("click", function DateInputComponent_footer_36_ng_container_7_Template_button_click_1_listener() {
      const shortcut_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.shortcutClick(shortcut_r6.typeId));
    });
    i0.ɵɵtemplate(2, DateInputComponent_footer_36_ng_container_7_b_2_Template, 3, 3, "b", 8)(3, DateInputComponent_footer_36_ng_container_7_span_3_Template, 3, 3, "span", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const shortcut_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.choosedType === shortcut_r6.typeId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.choosedType !== shortcut_r6.typeId);
  }
}
function DateInputComponent_footer_36_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "footer")(1, "div", 10)(2, "h5", 11)(3, "b");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "section");
    i0.ɵɵtemplate(7, DateInputComponent_footer_36_ng_container_7_Template, 4, 2, "ng-container", 7);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 2, ctx_r2.sharedStrings.shortcuts));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2.shortcuts);
  }
}
const _c0 = a0 => ({
  "font-weight-bold": a0
});
function DateTimePickerComponent_a_12_div_1_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "wg-icon", 21);
    i0.ɵɵelementEnd();
  }
}
function DateTimePickerComponent_a_12_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "span", 19);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, DateTimePickerComponent_a_12_div_1_span_4_Template, 2, 0, "span", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const preset_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0, ctx_r2.boldPresets));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, preset_r2.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", preset_r2.isCustom && (ctx_r2.customButtonItems == null ? null : ctx_r2.customButtonItems.length));
  }
}
function DateTimePickerComponent_a_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 16);
    i0.ɵɵlistener("click", function DateTimePickerComponent_a_12_Template_a_click_0_listener() {
      const preset_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.presetClick(preset_r2));
    });
    i0.ɵɵtemplate(1, DateTimePickerComponent_a_12_div_1_Template, 5, 7, "div", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const preset_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("active", preset_r2.isCustom && ctx_r2.showCustom);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", preset_r2.show || preset_r2.show === undefined);
  }
}
function DateTimePickerComponent_div_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "wg-select-button", 22);
    i0.ɵɵlistener("optionClick", function DateTimePickerComponent_div_14_Template_wg_select_button_optionClick_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.optionClicked($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("options", ctx_r2.customButtonItems);
  }
}
function DateTimePickerComponent_wg_date_input_22_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "wg-date-input", 23);
    i0.ɵɵtwoWayListener("ngModelChange", function DateTimePickerComponent_wg_date_input_22_Template_wg_date_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.startDateString, $event) || (ctx_r2.startDateString = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function DateTimePickerComponent_wg_date_input_22_Template_wg_date_input_change_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.startDateChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dateFormat", ctx_r2.dateFormat);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.startDateString);
  }
}
function DateTimePickerComponent_wg_date_input_23_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "wg-date-input", 24);
    i0.ɵɵtwoWayListener("ngModelChange", function DateTimePickerComponent_wg_date_input_23_Template_wg_date_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.startDateString, $event) || (ctx_r2.startDateString = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function DateTimePickerComponent_wg_date_input_23_Template_wg_date_input_change_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.startDateChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dateFormat", ctx_r2.dateFormat);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.startDateString);
    i0.ɵɵproperty("min", ctx_r2.minDate)("max", ctx_r2.maxDate);
  }
}
function DateTimePickerComponent_div_24_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "wg-time-input", 25);
    i0.ɵɵtwoWayListener("ngModelChange", function DateTimePickerComponent_div_24_Template_wg_time_input_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.startTime, $event) || (ctx_r2.startTime = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, ctx_r2.sharedStrings.time));
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.startTime);
  }
}
function DateTimePickerComponent_wg_date_input_32_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "wg-date-input", 26);
    i0.ɵɵtwoWayListener("ngModelChange", function DateTimePickerComponent_wg_date_input_32_Template_wg_date_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.endDateString, $event) || (ctx_r2.endDateString = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function DateTimePickerComponent_wg_date_input_32_Template_wg_date_input_change_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.endDateChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dateFormat", ctx_r2.dateFormat);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.endDateString);
    i0.ɵɵproperty("min", ctx_r2.startDate);
  }
}
function DateTimePickerComponent_wg_date_input_33_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "wg-date-input", 24);
    i0.ɵɵtwoWayListener("ngModelChange", function DateTimePickerComponent_wg_date_input_33_Template_wg_date_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.endDateString, $event) || (ctx_r2.endDateString = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function DateTimePickerComponent_wg_date_input_33_Template_wg_date_input_change_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.endDateChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dateFormat", ctx_r2.dateFormat);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.endDateString);
    i0.ɵɵproperty("min", ctx_r2.startDate)("max", ctx_r2.maxDate);
  }
}
function DateTimePickerComponent_div_34_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "wg-time-input", 25);
    i0.ɵɵtwoWayListener("ngModelChange", function DateTimePickerComponent_div_34_Template_wg_time_input_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.endTime, $event) || (ctx_r2.endTime = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, ctx_r2.sharedStrings.time));
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.endTime);
  }
}
const _c1 = ["sliderHandle"];
const _c2 = ["sliderHandleStart"];
const _c3 = ["sliderHandleEnd"];
const _c4 = (a0, a1, a2, a3) => ({
  "p-slider p-component": true,
  "p-disabled": a0,
  "p-slider-horizontal": a1,
  "p-slider-vertical": a2,
  "p-slider-animate": a3
});
const _c5 = (a0, a1) => ({
  "left": a0,
  width: a1
});
const _c6 = (a0, a1) => ({
  "bottom": a0,
  height: a1
});
const _c7 = a0 => ({
  "height": a0
});
const _c8 = a0 => ({
  "width": a0
});
const _c9 = (a0, a1) => ({
  "left": a0,
  "bottom": a1
});
const _c10 = a0 => ({
  "p-slider-handle-active": a0
});
function WgSliderComponent_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(1, _c5, ctx_r0.handleValues[0] + "%", ctx_r0.handleValues[1] - ctx_r0.handleValues[0] + "%"));
  }
}
function WgSliderComponent_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(1, _c6, ctx_r0.handleValues[0] + "%", ctx_r0.handleValues[1] - ctx_r0.handleValues[0] + "%"));
  }
}
function WgSliderComponent_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c7, ctx_r0.handleValue + "%"));
  }
}
function WgSliderComponent_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c8, ctx_r0.handleValue + "%"));
  }
}
function WgSliderComponent_span_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 8, 0);
    i0.ɵɵlistener("keydown", function WgSliderComponent_span_5_Template_span_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onHandleKeydown($event));
    })("mousedown", function WgSliderComponent_span_5_Template_span_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onMouseDown($event));
    })("touchstart", function WgSliderComponent_span_5_Template_span_touchstart_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onTouchStart($event));
    })("touchmove", function WgSliderComponent_span_5_Template_span_touchmove_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onTouchMove($event));
    })("touchend", function WgSliderComponent_span_5_Template_span_touchend_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onTouchEnd($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("transition", ctx_r0.dragging ? "none" : null);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(8, _c9, ctx_r0.orientation === "horizontal" ? ctx_r0.handleValue + "%" : null, ctx_r0.orientation === "vertical" ? ctx_r0.handleValue + "%" : null));
    i0.ɵɵattribute("tabindex", ctx_r0.disabled ? null : ctx_r0.tabindex)("aria-valuemin", ctx_r0.min)("aria-valuenow", ctx_r0.value)("aria-valuemax", ctx_r0.max)("aria-labelledby", ctx_r0.ariaLabelledBy);
  }
}
function WgSliderComponent_span_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 9, 1);
    i0.ɵɵlistener("keydown", function WgSliderComponent_span_6_Template_span_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onHandleKeydown($event, 0));
    })("mousedown", function WgSliderComponent_span_6_Template_span_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onMouseDown($event, 0));
    })("touchstart", function WgSliderComponent_span_6_Template_span_touchstart_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onTouchStart($event, 0));
    })("touchmove", function WgSliderComponent_span_6_Template_span_touchmove_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onTouchMove($event, 0));
    })("touchend", function WgSliderComponent_span_6_Template_span_touchend_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onTouchEnd($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("transition", ctx_r0.dragging ? "none" : null);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(9, _c9, ctx_r0.rangeStartLeft, ctx_r0.rangeStartBottom))("ngClass", i0.ɵɵpureFunction1(12, _c10, ctx_r0.handleIndex === 0));
    i0.ɵɵattribute("tabindex", ctx_r0.disabled ? null : ctx_r0.tabindex)("aria-valuemin", ctx_r0.min)("aria-valuenow", ctx_r0.value ? ctx_r0.value[0] : null)("aria-valuemax", ctx_r0.max)("aria-labelledby", ctx_r0.ariaLabelledBy);
  }
}
function WgSliderComponent_span_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 9, 2);
    i0.ɵɵlistener("keydown", function WgSliderComponent_span_7_Template_span_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onHandleKeydown($event, 1));
    })("mousedown", function WgSliderComponent_span_7_Template_span_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onMouseDown($event, 1));
    })("touchstart", function WgSliderComponent_span_7_Template_span_touchstart_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onTouchStart($event, 1));
    })("touchmove", function WgSliderComponent_span_7_Template_span_touchmove_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onTouchMove($event, 1));
    })("touchend", function WgSliderComponent_span_7_Template_span_touchend_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onTouchEnd($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("transition", ctx_r0.dragging ? "none" : null);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(9, _c9, ctx_r0.rangeEndLeft, ctx_r0.rangeEndBottom))("ngClass", i0.ɵɵpureFunction1(12, _c10, ctx_r0.handleIndex === 1));
    i0.ɵɵattribute("tabindex", ctx_r0.disabled ? null : ctx_r0.tabindex)("aria-valuemin", ctx_r0.min)("aria-valuenow", ctx_r0.value ? ctx_r0.value[1] : null)("aria-valuemax", ctx_r0.max)("aria-labelledby", ctx_r0.ariaLabelledBy);
  }
}
function DayTimeRangeComponent_div_0_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const entry_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", entry_r2.formattedValues[0], "-", entry_r2.formattedValues[1], " ");
  }
}
function DayTimeRangeComponent_div_0_li_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const number_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(number_r4);
  }
}
function DayTimeRangeComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div")(2, "div", 1)(3, "div", 2)(4, "label", 3)(5, "input", 4);
    i0.ɵɵtwoWayListener("ngModelChange", function DayTimeRangeComponent_div_0_Template_input_ngModelChange_5_listener($event) {
      const entry_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      i0.ɵɵtwoWayBindingSet(entry_r2.checked, $event) || (entry_r2.checked = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("input", function DayTimeRangeComponent_div_0_Template_input_input_5_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.rangeCheckInput());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtemplate(8, DayTimeRangeComponent_div_0_ng_container_8_Template, 2, 2, "ng-container", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div")(10, "div", 6)(11, "ul", 7);
    i0.ɵɵtemplate(12, DayTimeRangeComponent_div_0_li_12_Template, 3, 1, "li", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "wg-slider", 8);
    i0.ɵɵtwoWayListener("ngModelChange", function DayTimeRangeComponent_div_0_Template_wg_slider_ngModelChange_13_listener($event) {
      const entry_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      i0.ɵɵtwoWayBindingSet(entry_r2.values, $event) || (entry_r2.values = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("onChange", function DayTimeRangeComponent_div_0_Template_wg_slider_onChange_13_listener() {
      const entry_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.rangeChange(entry_r2));
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const entry_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtwoWayProperty("ngModel", entry_r2.checked);
    i0.ɵɵproperty("disabled", ctx_r2.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", entry_r2.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", entry_r2.formattedValues);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r2.numbers);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", entry_r2.values);
    i0.ɵɵproperty("range", true)("min", 0)("max", 24)("step", 0.5)("disabled", !entry_r2.checked || ctx_r2.disabled);
  }
}
const _c11 = ["*"];
function DurationInputComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "input", 2)(2, "wg-dropdown", 3);
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.form);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("dropdownList", ctx_r0.timeScales);
  }
}
var CALENDAR_PRESETS;
(function (CALENDAR_PRESETS) {
  CALENDAR_PRESETS[CALENDAR_PRESETS["TODAY"] = 0] = "TODAY";
  CALENDAR_PRESETS[CALENDAR_PRESETS["YESTERDAY"] = 1] = "YESTERDAY";
  CALENDAR_PRESETS[CALENDAR_PRESETS["LAST_24_HOURS"] = 2] = "LAST_24_HOURS";
  CALENDAR_PRESETS[CALENDAR_PRESETS["LAST_7_DAYS"] = 3] = "LAST_7_DAYS";
  CALENDAR_PRESETS[CALENDAR_PRESETS["LAST_14_DAYS"] = 4] = "LAST_14_DAYS";
  CALENDAR_PRESETS[CALENDAR_PRESETS["THIS_MONTH"] = 5] = "THIS_MONTH";
  CALENDAR_PRESETS[CALENDAR_PRESETS["LAST_MONTH"] = 6] = "LAST_MONTH";
  CALENDAR_PRESETS[CALENDAR_PRESETS["CUSTOM"] = 7] = "CUSTOM";
})(CALENDAR_PRESETS || (CALENDAR_PRESETS = {}));
const SHARED_STRINGS = {
  done: 'done_lbl',
  from: 'from_lbl',
  to: 'to_lbl',
  date: 'datetimepicker_date',
  time: 'datetimepicker_time',
  cancel: 'cancel_lbl',
  save: 'save_lbl',
  days: 'datetimepicker_days',
  hours: 'datetimepicker_hours',
  minutes: 'datetimepicker_minutes',
  seconds: 'datetimepicker_seconds',
  today: 'datetimepicker_today',
  yesterday: 'datetimepicker_yesterday',
  last_24_hours: 'datetimepicker_last_24_hours',
  lbl_7_days: 'datetimepicker_7_days',
  lbl_14_days: 'datetimepicker_14_days',
  lbl_30_days: 'datetimepicker_30_days',
  last_7_days: 'datetimepicker_last_7_days',
  last_14_days: 'datetimepicker_last_14_days',
  this_month: 'datetimepicker_this_month',
  last_month: 'datetimepicker_last_month',
  custom: 'datetimepicker_custom',
  show_time_note: 'datetimepicker_show_time_note',
  shortcuts: 'datetimepicker_shortcuts',
  one_month: 'datetimepicker_one_month',
  one_year: 'datetimepicker_one_year',
  three_years: 'datetimepicker_three_years',
  time_note: 'timeinput_time_note'
};
const CALENDAR_STRINGS = {
  sunday: 'sunday_calendar',
  monday: 'monday_calendar',
  tuesday: 'tuesday_calendar',
  wednesday: 'wednesday_calendar',
  thursday: 'thursday_calendar',
  friday: 'friday_calendar',
  saturday: 'saturday_calendar',
  sunday_short: 'sunday_short_calendar',
  monday_short: 'monday_short_calendar',
  tuesday_short: 'tuesday_short_calendar',
  wednesday_short: 'wednesday_short_calendar',
  thursday_short: 'thursday_short_calendar',
  friday_short: 'friday_short_calendar',
  saturday_short: 'saturday_short_calendar',
  january: 'january_calendar',
  february: 'february_calendar',
  march: 'march_calendar',
  april: 'april_calendar',
  may: 'may_calendar',
  june: 'june_calendar',
  july: 'july_calendar',
  august: 'august_calendar',
  september: 'september_calendar',
  october: 'october_calendar',
  november: 'november_calendar',
  december: 'december_calendar'
};
const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
class DateInputComponent {
  constructor(elementRef, translateService) {
    this.elementRef = elementRef;
    this.translateService = translateService;
    this.dateInputClass = true;
    this.dateFormat = DEFAULT_DATE_FORMAT;
    this.disabled = false;
    this.placeholder = '';
    this.shortcut = false;
    this.showDays = false;
    // eslint-disable-next-line @angular-eslint/no-output-native
    this.change = new EventEmitter();
    this.showPopover = false;
    this.calendarStrings = CALENDAR_STRINGS;
    this.sharedStrings = SHARED_STRINGS;
    this.shortcuts = [{
      typeId: 1,
      typeLabel: this.sharedStrings.one_month
    }, {
      typeId: 2,
      typeLabel: this.sharedStrings.one_year
    }, {
      typeId: 3,
      typeLabel: this.sharedStrings.three_years
    }];
    this.onChange = dateString => {};
    this.onTouched = () => {};
  }
  ngOnChanges(changes) {
    if (changes.dateFormat) {
      if (this.dateFormat === undefined) {
        this.dateFormat = DEFAULT_DATE_FORMAT;
      }
      this.formatDateString();
    }
    if (changes.max) {
      this.maxMoment = moment(changes.max.currentValue);
      if (this.isInvalidMoment(this.maxMoment)) {
        this.maxMoment = undefined;
      }
    }
    if (changes.min) {
      this.minMoment = moment(changes.min.currentValue);
      if (this.isInvalidMoment(this.minMoment)) {
        this.minMoment = undefined;
      }
    }
    if (this.showDays) {
      this.shortcuts = [{
        typeId: 1,
        typeLabel: this.sharedStrings.lbl_7_days
      }, {
        typeId: 2,
        typeLabel: this.sharedStrings.lbl_14_days
      }, {
        typeId: 3,
        typeLabel: this.sharedStrings.lbl_30_days
      }];
    }
    this.refreshCalendar();
  }
  calendarChangeMonth(monthsToAdd) {
    if (this.isInvalidMoment(this.calendarMoment)) {
      return;
    }
    this.calendarMoment.add(monthsToAdd, 'month');
    this.refreshCalendar();
  }
  calendarDayClick(event, day) {
    this.choosedType = 0;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (day.disabled) {
      return;
    }
    this.dateString = day.moment.format(this.dateFormat);
    this.onChange(this.dateString);
    this.change.emit(this.dateString);
    this.showPopover = false;
  }
  shortcutClick(type) {
    let shortcuts = moment();
    this.choosedType = type;
    if (this.choosedType === 1) {
      shortcuts = this.showDays ? shortcuts.add(7, 'day') : shortcuts.add(1, 'month');
    } else if (this.choosedType === 2) {
      shortcuts = this.showDays ? shortcuts.add(14, 'day') : shortcuts.add(1, 'year');
    } else if (this.choosedType === 3) {
      shortcuts = this.showDays ? shortcuts.add(30, 'day') : shortcuts.add(3, 'year');
    }
    this.dateString = shortcuts.format(this.dateFormat);
    this.onChange(this.dateString);
    this.change.emit(this.dateString);
    this.showPopover = false;
  }
  clickout(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showPopover = false;
    }
  }
  getTranslatedMonth(month) {
    if (month) {
      const monthKey = this.calendarStrings[month.toLowerCase()];
      if (monthKey) {
        return this.translateService.instant(monthKey);
      }
    }
    return '';
  }
  inputOnClick(event) {
    if (!this.disabled) {
      this.onTouched();
      this.togglePopover();
    }
  }
  inputOnKeydown(event) {
    // capture Enter | Keydown event to close the pop over
    if (event.keyCode === 13 || event.keyCode === 9) {
      this.togglePopover(false);
    }
  }
  inputOnInput(event) {
    this.togglePopover(false);
    const inputMoment = this.getMoment(this.dateString);
    if (this.isValidMoment(inputMoment)) {
      this.selectedMoment = inputMoment.clone();
    } else {
      this.selectedMoment = undefined;
    }
    this.onChange(this.dateString);
    this.change.emit(this.dateString);
  }
  togglePopover(show) {
    this.showPopover = show === undefined ? !this.showPopover : show;
    if (this.showPopover) {
      this.calendarMoment = undefined;
      this.refreshCalendar();
    }
  }
  formatDateString() {
    if (this.isValidMoment(this.selectedMoment)) {
      this.dateString = this.selectedMoment.format(this.dateFormat);
      this.onChange(this.dateString);
    }
  }
  getMoment(dateString) {
    return moment(dateString, this.dateFormat);
  }
  isValidMoment(momentToValidate) {
    return momentToValidate && moment.isMoment(momentToValidate) && momentToValidate.isValid();
  }
  isInvalidMoment(momentToValidate) {
    return !(momentToValidate && moment.isMoment(momentToValidate) && momentToValidate.isValid());
  }
  refreshCalendar() {
    this.selectedMoment = this.getMoment(this.dateString);
    if (this.isInvalidMoment(this.selectedMoment)) {
      this.selectedMoment = undefined;
      if (this.isInvalidMoment(this.calendarMoment)) {
        this.calendarMoment = moment();
      }
    } else if (this.isInvalidMoment(this.calendarMoment)) {
      this.calendarMoment = this.selectedMoment.clone();
    }
    this.formattedMonth = this.calendarMoment.format('MMMM');
    this.formattedYear = this.calendarMoment.format('YYYY');
    this.calendarWeeks = new Array();
    const startDay = this.calendarMoment.clone().startOf('month').startOf('week');
    const endDay = this.calendarMoment.clone().endOf('month').endOf('week');
    const index = startDay.clone();
    let calendarWeek = {
      days: new Array()
    };
    while (index.isBefore(endDay.clone().add(1, 'day'), 'day')) {
      calendarWeek.days.push({
        label: index.date().toString(),
        moment: index.clone(),
        // tslint:disable-next-line:max-line-length
        active: this.isValidMoment(this.selectedMoment) && index.month() === this.selectedMoment.month() && index.valueOf() === this.selectedMoment.valueOf(),
        // tslint:disable-next-line:max-line-length
        disabled: index.month() !== this.calendarMoment.month() || this.maxMoment && index.isAfter(this.maxMoment) || this.minMoment && index.isBefore(this.minMoment)
      });
      if (index.day() === 6) {
        this.calendarWeeks.push(calendarWeek);
        calendarWeek = {
          days: new Array()
        };
      }
      index.add(1, 'day');
    }
  }
  // ControlValueAccessor methods
  get value() {
    return this.dateString;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  writeValue(dateString) {
    if (dateString instanceof Date) {
      dateString = dateString.toISOString();
    }
    let inputMoment = this.getMoment(dateString);
    if (this.isInvalidMoment(inputMoment)) {
      inputMoment = moment(dateString);
    }
    if (this.isValidMoment(inputMoment)) {
      this.selectedMoment = inputMoment.clone();
      this.formatDateString();
    } else {
      this.dateString = dateString;
    }
    this.onChange(this.dateString);
  }
  static {
    this.ɵfac = function DateInputComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DateInputComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DateInputComponent,
      selectors: [["wg-date-input"]],
      hostVars: 4,
      hostBindings: function DateInputComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function DateInputComponent_click_HostBindingHandler($event) {
            return ctx.clickout($event);
          }, false, i0.ɵɵresolveDocument);
        }
        if (rf & 2) {
          i0.ɵɵclassProp("wg-date-input", ctx.dateInputClass)("disabled", ctx.disabled);
        }
      },
      inputs: {
        dateFormat: "dateFormat",
        disabled: "disabled",
        min: "min",
        max: "max",
        placeholder: "placeholder",
        shortcut: "shortcut",
        showDays: "showDays"
      },
      outputs: {
        change: "change"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DateInputComponent),
        multi: true
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 37,
      vars: 30,
      consts: [[1, "form-control", "ft-date", 3, "ngModelChange", "click", "input", "keydown", "ngModel", "disabled", "placeholder"], ["name", "calendar", 3, "click"], [1, "popover"], [3, "click"], ["name", "angle-left"], ["name", "angle-right"], [1, "days"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "active", "disabled", "click", 4, "ngFor", "ngForOf"], [1, "mt-3", "ml-2"], [1, "mb-0"], [1, "btn", "btn-icon-and-text", 3, "click"]],
      template: function DateInputComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "input", 0);
          i0.ɵɵtwoWayListener("ngModelChange", function DateInputComponent_Template_input_ngModelChange_0_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.dateString, $event) || (ctx.dateString = $event);
            return $event;
          });
          i0.ɵɵlistener("click", function DateInputComponent_Template_input_click_0_listener($event) {
            return ctx.inputOnClick($event);
          })("input", function DateInputComponent_Template_input_input_0_listener($event) {
            return ctx.inputOnInput($event);
          })("keydown", function DateInputComponent_Template_input_keydown_0_listener($event) {
            return ctx.inputOnKeydown($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(1, "wg-icon", 1);
          i0.ɵɵlistener("click", function DateInputComponent_Template_wg_icon_click_1_listener($event) {
            return ctx.inputOnClick($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "div", 2)(3, "header")(4, "a", 3);
          i0.ɵɵlistener("click", function DateInputComponent_Template_a_click_4_listener() {
            return ctx.calendarChangeMonth(-1);
          });
          i0.ɵɵelement(5, "wg-icon", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "span");
          i0.ɵɵtext(7);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "a", 3);
          i0.ɵɵlistener("click", function DateInputComponent_Template_a_click_8_listener() {
            return ctx.calendarChangeMonth(1);
          });
          i0.ɵɵelement(9, "wg-icon", 5);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(10, "table", 6)(11, "thead")(12, "tr")(13, "th");
          i0.ɵɵtext(14);
          i0.ɵɵpipe(15, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(16, "th");
          i0.ɵɵtext(17);
          i0.ɵɵpipe(18, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(19, "th");
          i0.ɵɵtext(20);
          i0.ɵɵpipe(21, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(22, "th");
          i0.ɵɵtext(23);
          i0.ɵɵpipe(24, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(25, "th");
          i0.ɵɵtext(26);
          i0.ɵɵpipe(27, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(28, "th");
          i0.ɵɵtext(29);
          i0.ɵɵpipe(30, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(31, "th");
          i0.ɵɵtext(32);
          i0.ɵɵpipe(33, "translate");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(34, "tbody");
          i0.ɵɵtemplate(35, DateInputComponent_tr_35_Template, 2, 1, "tr", 7);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(36, DateInputComponent_footer_36_Template, 8, 4, "footer", 8);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵtwoWayProperty("ngModel", ctx.dateString);
          i0.ɵɵproperty("disabled", ctx.disabled)("placeholder", ctx.placeholder);
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("show", ctx.showPopover);
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate2("", ctx.getTranslatedMonth(ctx.formattedMonth), " ", ctx.formattedYear, "");
          i0.ɵɵadvance(7);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 16, ctx.calendarStrings.sunday_short));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 18, ctx.calendarStrings.monday_short));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 20, ctx.calendarStrings.tuesday_short));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(24, 22, ctx.calendarStrings.wednesday_short));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(27, 24, ctx.calendarStrings.thursday_short));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(30, 26, ctx.calendarStrings.friday_short));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(33, 28, ctx.calendarStrings.saturday_short));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngForOf", ctx.calendarWeeks);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.shortcut);
        }
      },
      dependencies: [i2.NgForOf, i2.NgIf, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i4.WgIconComponent, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateInputComponent, [{
    type: Component,
    args: [{
      selector: 'wg-date-input',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DateInputComponent),
        multi: true
      }],
      standalone: false,
      template: "<input class=\"form-control ft-date\"\n       [(ngModel)]=\"dateString\"\n       (click)=\"inputOnClick($event)\"\n       (input)=\"inputOnInput($event)\"\n       (keydown)=\"inputOnKeydown($event)\"\n       [disabled]=\"disabled\"\n       [placeholder]=\"placeholder\">\n<wg-icon name=\"calendar\"\n    (click)=\"inputOnClick($event)\"></wg-icon>\n\n<div class=\"popover\" [class.show]=\"showPopover\">\n  <header>\n    <a (click)=\"calendarChangeMonth(-1)\"><wg-icon name=\"angle-left\"></wg-icon></a>\n    <span>{{ getTranslatedMonth(formattedMonth) }} {{ formattedYear }}</span>\n    <a (click)=\"calendarChangeMonth(1)\"><wg-icon name=\"angle-right\"></wg-icon></a>\n  </header>\n\n  <table class=\"days\">\n    <thead>\n      <tr>\n        <th>{{ calendarStrings.sunday_short | translate }}</th>\n        <th>{{ calendarStrings.monday_short | translate }}</th>\n        <th>{{ calendarStrings.tuesday_short | translate }}</th>\n        <th>{{ calendarStrings.wednesday_short | translate }}</th>\n        <th>{{ calendarStrings.thursday_short | translate }}</th>\n        <th>{{ calendarStrings.friday_short | translate }}</th>\n        <th>{{ calendarStrings.saturday_short | translate }}</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr *ngFor=\"let calendarWeek of calendarWeeks\">\n        <td *ngFor=\"let day of calendarWeek.days\" (click)=\"calendarDayClick($event, day)\" [class.active]=\"day.active\" [class.disabled]=\"day.disabled\">\n          <span>{{ day.label }}</span>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n\n  <footer *ngIf=\"shortcut\">\n    <div class=\"mt-3 ml-2\">\n      <h5 class=\"mb-0\"><b>{{ sharedStrings.shortcuts | translate }}</b></h5>\n      <section>\n        <ng-container *ngFor=\"let shortcut of shortcuts\">\n          <button class=\"btn btn-icon-and-text\" (click)=\"shortcutClick(shortcut.typeId)\">\n            <b *ngIf=\"choosedType === shortcut.typeId\">{{ shortcut.typeLabel | translate }}</b>\n            <span *ngIf=\"choosedType !== shortcut.typeId\">{{ shortcut.typeLabel | translate }}</span>\n          </button>\n        </ng-container>\n      </section>\n    </div>\n  </footer>\n</div>\n"
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i1.TranslateService
  }], {
    dateInputClass: [{
      type: HostBinding,
      args: ['class.wg-date-input']
    }],
    dateFormat: [{
      type: Input
    }],
    disabled: [{
      type: HostBinding,
      args: ['class.disabled']
    }, {
      type: Input
    }],
    min: [{
      type: Input
    }],
    max: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    shortcut: [{
      type: Input
    }],
    showDays: [{
      type: Input
    }],
    change: [{
      type: Output
    }],
    clickout: [{
      type: HostListener,
      args: ['document:click', ['$event']]
    }]
  });
})();

/**
 * Time Input Component
 *
 * NOTE on the HOUR = 24:
 * You'll notice the hour goes up to 24. This is because during user testing we told them to set the times to 1/1/2018 @ 12:00am
 * to 1/2/2018 @ midnight and in all the tests they selected hour = 12 for midnight. We ran the tests again with a fake 24
 * (for end of day) and for the most part they all selected the 24. So apparently the 24 makes it easier to understand
 * the 24-hour clock
 */
const TIME_FORMAT$1 = 'HH:mm';
class TimeInputComponent {
  constructor(elementRef) {
    this.elementRef = elementRef;
    this.timeInputClass = true;
    this.disabled = false;
    this.timeFormat = TIME_FORMAT$1;
    this.sharedStrings = SHARED_STRINGS;
    this.propagateChange = () => {};
  }
  ngOnChanges(changes) {
    for (const change in changes) {
      if (change === 'timeFormat' && !changes[change].isFirstChange()) {
        this.formattedTime = this.formatTime(this._moment);
      }
    }
  }
  get value() {
    return this._value;
  }
  set value(value) {
    if (value !== this._value) {
      this.propagateChange(value);
      this._value = value;
      this._moment = moment(value);
      if (this.isValidMoment(this._moment)) {
        this.formattedTime = this.formatTime(this._moment);
      }
    }
  }
  clickout(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showPopover = false;
    }
  }
  inputChanged() {
    const testMoment = moment(this.formattedTime, this.timeFormat);
    if (this.isValidMoment(testMoment)) {
      this.writeValue(testMoment.toDate());
    } else {
      const defaultDate = new Date();
      const time = this.formattedTime.split(':');
      if (time.length > 0 && this.isNumber(time[0]) && Math.abs(parseInt(time[0], 10)) < 24) {
        defaultDate.setHours(Math.abs(parseInt(time[0], 10)), 59, 0, 0);
      } else {
        defaultDate.setHours(0, 0, 0, 0);
      }
      this.writeValue(defaultDate);
    }
  }
  inputKeydown(event) {
    const keyCode = event.key;
    if (keyCode === 'Tab') {
      this.showPopover = false;
    } else if (keyCode === 'Enter') {
      this.togglePopover();
    }
  }
  isValidMoment(momentToValidate) {
    return momentToValidate && moment.isMoment(momentToValidate) && momentToValidate.isValid();
  }
  popoverClick(event) {
    event.stopImmediatePropagation();
  }
  registerOnChange(fn) {
    this.propagateChange = fn;
  }
  registerOnTouched() {}
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  save(hidePopover = false) {
    if (!this.isValidMoment(this._moment)) {
      this._moment = moment();
      this._moment.set('second', 0);
      this._moment.set('millisecond', 0);
    }
    if (this.hours === 24) {
      this._moment.set({
        'hours': 23,
        'minutes': 59,
        'seconds': 59,
        'milliseconds': 999
      });
    } else {
      this._moment.set({
        'hours': this.hours,
        'minutes': this.minutes,
        'seconds': 0,
        'milliseconds': 0
      });
    }
    this.value = this._moment.toDate();
    if (hidePopover) {
      this.showPopover = false;
    }
  }
  slidersChanged() {
    if (this.hours === 24) {
      this.minutes = 0;
      this.minutesDisabled = true;
    } else {
      this.minutesDisabled = false;
    }
    this.save();
  }
  togglePopover(visible) {
    if (this.disabled) {
      this.showPopover = false;
      return;
    }
    if (visible == null) {
      visible = !this.showPopover;
    }
    this.showPopover = visible;
    this.updateSliders();
  }
  writeValue(value) {
    if (value !== this._value) {
      this.value = value;
    }
    this.updateSliders();
  }
  formatTime(timeMoment) {
    if (this.isEndOfDay(timeMoment)) {
      let timeFormat24 = new String(this.timeFormat).toString();
      timeFormat24 = timeFormat24.replace('HH', '24');
      timeFormat24 = timeFormat24.replace('H', '24');
      timeFormat24 = timeFormat24.replace('kk', '24');
      timeFormat24 = timeFormat24.replace('k', '24');
      let timeMoment24 = timeMoment.clone();
      timeMoment.add(1, 'millisecond');
      return timeMoment.format(timeFormat24);
    } else {
      return timeMoment.format(this.timeFormat);
    }
  }
  isEndOfDay(timeMoment) {
    if (timeMoment.get('hour') === 23 && timeMoment.get('minute') === 59 && timeMoment.get('second') === 59 && timeMoment.get('millisecond') === 999) {
      return true;
    }
    return false;
  }
  updateSliders() {
    this._moment = moment(this.value);
    if (this.isValidMoment(this._moment)) {
      if (this.isEndOfDay(this._moment)) {
        this.hours = 24;
        this.minutes = 0;
        this.minutesDisabled = true;
      } else {
        this.hours = this._moment.get('hours');
        this.minutes = this._moment.get('minutes');
        this.minutesDisabled = false;
      }
    }
  }
  isNumber(value) {
    const numbersRegex = new RegExp('^-?[0-9]+$');
    return numbersRegex.test(value);
  }
  static {
    this.ɵfac = function TimeInputComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimeInputComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TimeInputComponent,
      selectors: [["wg-time-input"]],
      hostVars: 6,
      hostBindings: function TimeInputComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function TimeInputComponent_click_HostBindingHandler($event) {
            return ctx.clickout($event);
          }, false, i0.ɵɵresolveDocument);
        }
        if (rf & 2) {
          i0.ɵɵclassProp("wg-time-input", ctx.timeInputClass)("disabled", ctx.disabled)("popover-show", ctx.showPopover);
        }
      },
      inputs: {
        disabled: "disabled",
        placeholder: "placeholder",
        timeFormat: "timeFormat"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TimeInputComponent),
        multi: true
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 32,
      vars: 20,
      consts: [[1, "form-control", 3, "ngModelChange", "change", "click", "focus", "keydown", "ngModel", "placeholder", "disabled"], ["name", "clock", 3, "click"], [1, "popover", 3, "click"], [1, "time-sliders"], [1, "hour"], [1, "form-group"], [1, "range-labels"], ["type", "range", "min", "0", "max", "24", "step", "1", 1, "form-control", 3, "ngModelChange", "change", "input", "ngModel"], [1, "minute"], ["type", "range", "min", "0", "max", "59", 1, "form-control", 3, "ngModelChange", "change", "input", "ngModel", "disabled"], [1, "form-actions"], [3, "innerHTML"], ["type", "button", 1, "btn", "btn-primary", 3, "click"]],
      template: function TimeInputComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "input", 0);
          i0.ɵɵtwoWayListener("ngModelChange", function TimeInputComponent_Template_input_ngModelChange_0_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.formattedTime, $event) || (ctx.formattedTime = $event);
            return $event;
          });
          i0.ɵɵlistener("change", function TimeInputComponent_Template_input_change_0_listener() {
            return ctx.inputChanged();
          })("click", function TimeInputComponent_Template_input_click_0_listener() {
            return ctx.togglePopover(true);
          })("focus", function TimeInputComponent_Template_input_focus_0_listener() {
            return ctx.togglePopover(true);
          })("keydown", function TimeInputComponent_Template_input_keydown_0_listener($event) {
            return ctx.inputKeydown($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(1, "wg-icon", 1);
          i0.ɵɵlistener("click", function TimeInputComponent_Template_wg_icon_click_1_listener() {
            return ctx.togglePopover(true);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "div", 2);
          i0.ɵɵlistener("click", function TimeInputComponent_Template_div_click_2_listener($event) {
            return ctx.popoverClick($event);
          });
          i0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "div", 6)(7, "div");
          i0.ɵɵtext(8, "0");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "div");
          i0.ɵɵtext(10, "24");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(11, "input", 7);
          i0.ɵɵtwoWayListener("ngModelChange", function TimeInputComponent_Template_input_ngModelChange_11_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.hours, $event) || (ctx.hours = $event);
            return $event;
          });
          i0.ɵɵlistener("change", function TimeInputComponent_Template_input_change_11_listener() {
            return ctx.slidersChanged();
          })("input", function TimeInputComponent_Template_input_input_11_listener() {
            return ctx.slidersChanged();
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(12, "label");
          i0.ɵɵtext(13);
          i0.ɵɵpipe(14, "translate");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(15, "div", 8)(16, "div", 5)(17, "div", 6)(18, "div");
          i0.ɵɵtext(19, "0");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(20, "div");
          i0.ɵɵtext(21, "59");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(22, "input", 9);
          i0.ɵɵtwoWayListener("ngModelChange", function TimeInputComponent_Template_input_ngModelChange_22_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.minutes, $event) || (ctx.minutes = $event);
            return $event;
          });
          i0.ɵɵlistener("change", function TimeInputComponent_Template_input_change_22_listener() {
            return ctx.slidersChanged();
          })("input", function TimeInputComponent_Template_input_input_22_listener() {
            return ctx.slidersChanged();
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(23, "label");
          i0.ɵɵtext(24);
          i0.ɵɵpipe(25, "translate");
          i0.ɵɵelementEnd()()()();
          i0.ɵɵelementStart(26, "div", 10);
          i0.ɵɵelement(27, "p", 11);
          i0.ɵɵpipe(28, "translate");
          i0.ɵɵelementStart(29, "button", 12);
          i0.ɵɵlistener("click", function TimeInputComponent_Template_button_click_29_listener() {
            return ctx.save(true);
          });
          i0.ɵɵtext(30);
          i0.ɵɵpipe(31, "translate");
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵtwoWayProperty("ngModel", ctx.formattedTime);
          i0.ɵɵproperty("placeholder", ctx.placeholder)("disabled", ctx.disabled);
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("show", ctx.showPopover);
          i0.ɵɵadvance(9);
          i0.ɵɵtwoWayProperty("ngModel", ctx.hours);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 12, ctx.sharedStrings.hours));
          i0.ɵɵadvance(9);
          i0.ɵɵtwoWayProperty("ngModel", ctx.minutes);
          i0.ɵɵproperty("disabled", ctx.minutesDisabled);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(25, 14, ctx.sharedStrings.minutes));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(28, 16, ctx.sharedStrings.time_note), i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(31, 18, ctx.sharedStrings.done));
        }
      },
      dependencies: [i1$1.DefaultValueAccessor, i1$1.RangeValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i4.WgIconComponent, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimeInputComponent, [{
    type: Component,
    args: [{
      selector: 'wg-time-input',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TimeInputComponent),
        multi: true
      }],
      standalone: false,
      template: "<input class=\"form-control\"\n       [(ngModel)]=\"formattedTime\"\n       (change)=\"inputChanged()\"\n       (click)=\"togglePopover(true)\"\n       (focus)=\"togglePopover(true)\"\n       (keydown)=\"inputKeydown($event)\"\n       [placeholder]=\"placeholder\"\n       [disabled]=\"disabled\">\n<wg-icon name=\"clock\" (click)=\"togglePopover(true)\"></wg-icon>\n\n<div class=\"popover\" [class.show]=\"showPopover\" (click)=\"popoverClick($event)\">\n  <div class=\"time-sliders\">\n    <div class=\"hour\">\n      <div class=\"form-group\">\n        <div class=\"range-labels\">\n          <div>0</div>\n          <div>24</div>\n        </div>\n        <input type=\"range\" class=\"form-control\" min=\"0\" max=\"24\" step=\"1\" [(ngModel)]=\"hours\" (change)=\"slidersChanged()\" (input)=\"slidersChanged()\">\n        <label>{{ sharedStrings.hours | translate }}</label>\n      </div>\n    </div>\n    <div class=\"minute\">\n      <div class=\"form-group\">\n        <div class=\"range-labels\">\n          <div>0</div>\n          <div>59</div>\n        </div>\n        <input type=\"range\" class=\"form-control\" min=\"0\" max=\"59\" [(ngModel)]=\"minutes\" (change)=\"slidersChanged()\" (input)=\"slidersChanged()\" [disabled]=\"minutesDisabled\">\n        <label>{{ sharedStrings.minutes | translate }}</label>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"form-actions\">\n    <p [innerHTML]=\"sharedStrings.time_note | translate\"></p>\n    <button type=\"button\" class=\"btn btn-primary\" (click)=\"save(true)\">{{ sharedStrings.done | translate }}</button>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    timeInputClass: [{
      type: HostBinding,
      args: ['class.wg-time-input']
    }],
    disabled: [{
      type: HostBinding,
      args: ['class.disabled']
    }, {
      type: Input
    }],
    showPopover: [{
      type: HostBinding,
      args: ['class.popover-show']
    }],
    placeholder: [{
      type: Input
    }],
    timeFormat: [{
      type: Input
    }],
    clickout: [{
      type: HostListener,
      args: ['document:click', ['$event']]
    }]
  });
})();
const DATE_FORMAT = 'YYYY-MM-DD';
const TIME_FORMAT = 'HH:mm';
class DateTimePickerComponent {
  constructor(elementRef, translateService) {
    this.elementRef = elementRef;
    this.translateService = translateService;
    // Outputs for a single start and end
    this.startDateTimeChange = new EventEmitter();
    this.endDateTimeChange = new EventEmitter();
    this.dateTimeChange = new EventEmitter();
    this.sharedStrings = SHARED_STRINGS;
    this.presets = [{
      index: CALENDAR_PRESETS.TODAY,
      label: SHARED_STRINGS.today,
      dateStartFunction: () => {
        return moment().startOf('day').toDate();
      },
      dateEndFunction: () => {
        return moment().endOf('day').toDate();
      },
      dateTimeStringFunction: () => {
        return moment(this.startDate).format(DATE_FORMAT);
      },
      isCustom: false
    }, {
      index: CALENDAR_PRESETS.YESTERDAY,
      label: SHARED_STRINGS.yesterday,
      dateStartFunction: () => {
        return moment().subtract(1, 'days').startOf('day').toDate();
      },
      dateEndFunction: () => {
        return moment().subtract(1, 'days').endOf('day').toDate();
      },
      dateTimeStringFunction: () => {
        return moment(this.startDate).format(DATE_FORMAT);
      },
      isCustom: false
    }, {
      index: CALENDAR_PRESETS.LAST_24_HOURS,
      label: SHARED_STRINGS.last_24_hours,
      dateStartFunction: () => {
        return moment().subtract(1, 'days').toDate();
      },
      dateEndFunction: () => {
        return moment().toDate();
      },
      dateTimeStringFunction: () => {
        return this.defaultDateTimeString();
      },
      isCustom: false
    }, {
      index: CALENDAR_PRESETS.LAST_7_DAYS,
      label: SHARED_STRINGS.last_7_days,
      dateStartFunction: () => {
        return moment().subtract(7, 'days').startOf('day').toDate();
      },
      dateEndFunction: () => {
        return moment().endOf('day').toDate();
      },
      dateTimeStringFunction: () => {
        return this.defaultDateTimeString();
      },
      isCustom: false
    }, {
      index: CALENDAR_PRESETS.LAST_14_DAYS,
      label: SHARED_STRINGS.last_14_days,
      dateStartFunction: () => {
        return moment().subtract(14, 'days').startOf('day').toDate();
      },
      dateEndFunction: () => {
        return moment().endOf('day').toDate();
      },
      dateTimeStringFunction: () => {
        return this.defaultDateTimeString();
      },
      isCustom: false
    }, {
      index: CALENDAR_PRESETS.THIS_MONTH,
      label: SHARED_STRINGS.this_month,
      dateStartFunction: () => {
        return moment().startOf('month').toDate();
      },
      dateEndFunction: () => {
        return moment().endOf('month').toDate();
      },
      dateTimeStringFunction: () => {
        return this.defaultDateTimeString();
      },
      isCustom: false
    }, {
      index: CALENDAR_PRESETS.LAST_MONTH,
      label: SHARED_STRINGS.last_month,
      dateStartFunction: () => {
        return moment().subtract(1, 'months').startOf('month').toDate();
      },
      dateEndFunction: () => {
        return moment().subtract(1, 'months').endOf('month').toDate();
      },
      dateTimeStringFunction: () => {
        return this.defaultDateTimeString();
      },
      isCustom: false
    }, {
      index: CALENDAR_PRESETS.CUSTOM,
      label: SHARED_STRINGS.custom,
      dateStartFunction: undefined,
      dateEndFunction: undefined,
      dateTimeStringFunction: () => {
        return this.defaultDateTimeString();
      },
      isCustom: true
    }];
    this.showCustom = false;
    this.showDropdown = false;
    this.showTimes = false;
    this.dateFormat = DATE_FORMAT;
  }
  clickout(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showCustom = false;
      this.showDropdown = false;
    }
  }
  ngOnInit() {
    this.translateService.get(SHARED_STRINGS.to).subscribe(translation => {
      this.toLabel = translation;
      this.updateCustomPresets();
      // Check if we are given dates/times
      if (this.startDateTime && this.endDateTime) {
        this.updateCustomDateTime();
      } else if (this.presetUserSelection) {
        let preset = this.presets.find(preset => preset.index === this.presetUserSelection);
        if (preset === undefined) {
          preset = this.presets[0];
        }
        this.presetClick(preset);
      } else {
        // Just use a preset
        this.presetClick(this.presets[0]);
      }
    });
  }
  ngOnChanges(changes) {
    if (changes.startDateTime && !changes.startDateTime.isFirstChange() || changes.endDateTime && !changes.endDateTime.isFirstChange()) {
      this.updateCustomDateTime();
      this.showTimes = true;
    }
    if (changes.presetUserSelection && !changes.presetUserSelection.isFirstChange()) {
      this.selectedPreset = this.presets.find(preset => preset.index === this.presetUserSelection);
      if (this.selectedPreset === undefined) {
        this.selectedPreset = this.presets[0];
      }
      this.updateDisplay();
    }
    if (changes.hideCalenderPresets && !changes.hideCalenderPresets.isFirstChange() || changes.customPresets && !changes.customPresets.isFirstChange() || changes.presetOrder && !changes.presetOrder.isFirstChange()) {
      this.updateCustomPresets();
    }
  }
  updateCustomDateTime() {
    this.startDate = moment(this.startDateTime).startOf('day').toDate();
    this.startDateString = moment(this.startDate).format(DATE_FORMAT);
    this.endDate = moment(this.endDateTime).startOf('day').toDate();
    this.endDateString = moment(this.endDate).format(DATE_FORMAT);
    this.startTime = new Date(this.startDateTime.getTime());
    this.endTime = new Date(this.endDateTime.getTime());
    this.selectedPreset = this.presets.find(preset => preset.index === CALENDAR_PRESETS.CUSTOM);
    this.saveCustom();
  }
  updateCustomPresets() {
    // hide calender presets that are in the hideCalenderPresets
    if (this.hideCalenderPresets) {
      this.presets.forEach(preset => {
        preset.show = this.hideCalenderPresets.find(cp => preset.index === cp) ? false : true;
      });
    }
    // Check for custom presets
    if (this.customPresets && this.customPresets.length > 0) {
      this.customPresets.forEach(preset => {
        this.presets.push(preset);
      });
    }
    // reorder the preset list
    if (this.presetOrder && this.presetOrder.length > 0) {
      const orderedPresets = [];
      // add the preset to the orderedPresets list by presetOrder
      this.presetOrder.forEach(idx => {
        const preset = this.presets.find(preset => preset.index === idx);
        if (preset) {
          orderedPresets.push(preset);
        }
      });
      // append the reset presets to the end of orderedPresets
      this.presets.forEach(preset => {
        if (this.presetOrder.find(idx => preset.index === idx) === undefined) {
          orderedPresets.push(preset);
        }
      });
      this.presets = orderedPresets;
    }
  }
  cancelCustom() {
    this.showCustom = false;
  }
  endDateChanged(newEndDateString) {
    const endDateMoment = moment(newEndDateString, DATE_FORMAT);
    if (this.isValidMoment(endDateMoment)) {
      this.endDate = endDateMoment.toDate();
    }
  }
  isValidMoment(momentToValidate) {
    return momentToValidate && moment.isMoment(momentToValidate) && momentToValidate.isValid();
  }
  presetClick(preset) {
    if (!preset) {
      return;
    }
    this.selectedPreset = preset;
    if (preset.isCustom) {
      this.selectedPresetIsCustom = true;
      this.showCustom = true;
      this.startDate = new Date(this.savedStartDate);
      this.startDateString = moment(this.startDate).format(DATE_FORMAT);
      this.startTime = new Date(this.savedStartTime);
      this.endDate = new Date(this.savedEndDate);
      this.endDateString = moment(this.endDate).format(DATE_FORMAT);
      this.endTime = new Date(this.savedEndTime);
      if (this.customButtonItems?.length) {
        const selectedIdx = this.savedSelectedIdx === undefined ? this.customButtonItems.findIndex(option => {
          return option.selected;
        }) : this.savedSelectedIdx;
        this.customButtonItems[selectedIdx].selected = true;
        this.optionClicked(this.customButtonItems[selectedIdx], this.savedSelectedIdx === undefined);
      }
    } else {
      this.selectedPresetIsCustom = false;
      this.showCustom = false;
      this.savedSelectedIdx = undefined;
      this.startDate = preset.dateStartFunction();
      this.startDateString = moment(this.startDate).format(DATE_FORMAT);
      this.startTime = new Date(this.startDate.getTime());
      this.endDate = preset.dateEndFunction();
      this.endDateString = moment(this.endDate).format(DATE_FORMAT);
      this.endTime = new Date(this.endDate.getTime());
      this.saveTimes();
      this.showDropdown = false;
      this.emitChanges();
    }
  }
  saveCustom() {
    this.saveTimes();
    this.savedSelectedIdx = this.customButtonItems?.findIndex(option => option?.selected);
    this.showCustom = false;
    this.showDropdown = false;
    this.emitChanges();
  }
  saveTimes() {
    // combining the dates and times to test that the end date is equal to or after the start date
    const startCombined = this.combineDateAndTimeMoments(moment(this.startDate), moment(this.startTime));
    const endCombined = this.combineDateAndTimeMoments(moment(this.endDate), moment(this.endTime));
    if (!startCombined.isBefore(endCombined)) {
      const tmpCombined = startCombined.add(1, 'minutes');
      this.endDate = new Date(tmpCombined.toDate());
      this.endTime = new Date(tmpCombined.toDate());
    }
    this.savedStartDate = new Date(this.startDate);
    this.savedEndDate = new Date(this.endDate);
    if (this.selectedPresetIsCustom && !this.showTimes) {
      this.startTime = moment(this.savedStartDate).startOf('day').toDate();
      this.endTime = moment(this.savedEndDate).endOf('day').toDate();
    }
    this.savedStartTime = new Date(this.startTime);
    this.savedEndTime = new Date(this.endTime);
    this.updateDisplay();
  }
  startDateChanged(newStartDateString) {
    const startDateMoment = moment(newStartDateString, DATE_FORMAT);
    const endDateMoment = moment(this.endDate);
    if (this.isValidMoment(startDateMoment) && this.isValidMoment(endDateMoment)) {
      this.startDate = startDateMoment.toDate();
      if (!startDateMoment.isBefore(endDateMoment)) {
        const tmpCombined = startDateMoment.add(1, 'minutes');
        this.endDate = new Date(tmpCombined.toDate());
        this.endDateString = moment(this.endDate).format(DATE_FORMAT);
      }
    }
  }
  toggleDropdown() {
    if (this.isDisabled) {
      return;
    }
    this.showDropdown = !this.showDropdown;
    if (!this.showDropdown) {
      this.showCustom = false;
    }
  }
  updateDisplay() {
    if (this.selectedPreset) {
      this.selectedPresetName = this.selectedPreset.label;
      this.selectedPresetIsCustom = this.selectedPreset.isCustom;
      if (this.selectedPreset.dateTimeStringFunction !== undefined) {
        this.formattedDateString = this.selectedPreset.dateTimeStringFunction();
      } else {
        // use the default function to generate the date string
        this.formattedDateString = this.defaultDateTimeString();
      }
    }
  }
  emitChanges() {
    // Combine for full
    const start = new Date(this.startDate);
    start.setHours(this.startTime.getHours());
    start.setMinutes(this.startTime.getMinutes());
    start.setSeconds(this.startTime.getSeconds());
    const end = new Date(this.endDate);
    end.setHours(this.endTime.getHours());
    end.setMinutes(this.endTime.getMinutes());
    end.setSeconds(this.endTime.getSeconds());
    this.startDateTimeChange.emit(start);
    this.endDateTimeChange.emit(end);
    const dateTimeChange = {
      start: start,
      end: end,
      userPresetSelection: this.selectedPreset.index
    };
    if (this.savedSelectedIdx !== undefined) {
      dateTimeChange.customSelectedIdx = this.savedSelectedIdx;
    }
    this.dateTimeChange.emit(dateTimeChange);
  }
  optionClicked(selectedOption, resetValues = true) {
    this.customButtonItems.forEach((option, idx) => {
      if (option.value !== selectedOption.value) {
        option.selected = false;
      } else if (option.value === selectedOption.value && !selectedOption?.selected && !option?.selected) {
        option.selected = true;
      } else if (resetValues) {
        const value = Number(option.value);
        const subtractedMoment = moment().subtract(value - 1, 'days').startOf('day');
        const subtractedDate = subtractedMoment.toDate();
        const todayDate = moment().toDate();
        this.minDate = idx === 0 ? subtractedDate : moment(0).toDate();
        this.maxDate = idx === 0 ? todayDate : subtractedDate;
        this.startDate = this.maxDate;
        this.endDate = this.maxDate;
        this.startDateString = idx === 0 ? moment(this.startDate).format(DATE_FORMAT) : subtractedMoment.format(DATE_FORMAT);
        this.endDateString = idx === 0 ? moment(this.endDate).format(DATE_FORMAT) : subtractedMoment.format(DATE_FORMAT);
      }
    });
  }
  combineDateAndTimeMoments(startMoment, timeMoment) {
    const moment = startMoment.clone();
    moment.set({
      hours: timeMoment.get('hours'),
      minutes: timeMoment.get('minutes'),
      seconds: 0,
      milliseconds: 0
    });
    return moment;
  }
  defaultDateTimeString() {
    return moment(this.savedStartDate).format(DATE_FORMAT) + ', ' + this.formatTime(this.savedStartTime) + ' ' + this.toLabel + ' ' + moment(this.savedEndDate).format(DATE_FORMAT) + ', ' + this.formatTime(this.savedEndTime);
  }
  formatTime(time) {
    const timeMoment = moment(time);
    if (this.isEndOfDay(timeMoment)) {
      return '24:00';
    } else {
      return timeMoment.format(TIME_FORMAT);
    }
  }
  isEndOfDay(timeMoment) {
    if (timeMoment.get('hour') === 23 && timeMoment.get('minute') === 59 && timeMoment.get('second') === 59 && timeMoment.get('millisecond') === 999) {
      return true;
    }
    return false;
  }
  static {
    this.ɵfac = function DateTimePickerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DateTimePickerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DateTimePickerComponent,
      selectors: [["wg-page-date-picker"]],
      hostBindings: function DateTimePickerComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function DateTimePickerComponent_click_HostBindingHandler($event) {
            return ctx.clickout($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        hideCalenderPresets: "hideCalenderPresets",
        customButtonItems: "customButtonItems",
        customPresets: "customPresets",
        startDateTime: "startDateTime",
        endDateTime: "endDateTime",
        presetUserSelection: "presetUserSelection",
        presetOrder: "presetOrder",
        isDisabled: "isDisabled",
        boldPresets: "boldPresets",
        minDate: "minDate",
        maxDate: "maxDate"
      },
      outputs: {
        startDateTimeChange: "startDateTimeChange",
        endDateTimeChange: "endDateTimeChange",
        dateTimeChange: "dateTimeChange"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 46,
      vars: 40,
      consts: [[1, "wg-page-date-picker", 3, "click"], ["name", "calendar", 3, "ngClass"], [1, "preset-name"], ["name", "expanded", 3, "ngClass"], [1, "wg-page-date-picker-dropdown"], [3, "active", "click", 4, "ngFor", "ngForOf"], [1, "wg-page-date-picker-custom"], ["class", "form-group", 4, "ngIf"], [1, "form-group"], [3, "dateFormat", "ngModel", "ngModelChange", "change", 4, "ngIf"], [3, "dateFormat", "ngModel", "min", "max", "ngModelChange", "change", 4, "ngIf"], [3, "dateFormat", "ngModel", "min", "ngModelChange", "change", 4, "ngIf"], [1, "form-actions", "column"], ["type", "checkbox", 3, "ngModelChange", "ngModel"], [3, "innerHTML"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], [3, "click"], ["class", "d-flex justify-content-between", 4, "ngIf"], [1, "d-flex", "justify-content-between"], [3, "ngClass"], [4, "ngIf"], ["name", "angle-right-filled"], [1, "select-buttons", 3, "optionClick", "options"], [3, "ngModelChange", "change", "dateFormat", "ngModel"], [3, "ngModelChange", "change", "dateFormat", "ngModel", "min", "max"], [3, "ngModelChange", "ngModel"], [3, "ngModelChange", "change", "dateFormat", "ngModel", "min"]],
      template: function DateTimePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "a", 0);
          i0.ɵɵlistener("click", function DateTimePickerComponent_Template_a_click_0_listener() {
            return ctx.toggleDropdown();
          });
          i0.ɵɵelement(1, "wg-icon", 1);
          i0.ɵɵelementStart(2, "div")(3, "span", 2);
          i0.ɵɵtext(4);
          i0.ɵɵpipe(5, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "span");
          i0.ɵɵtext(7, ":");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "span");
          i0.ɵɵtext(9);
          i0.ɵɵelementEnd()();
          i0.ɵɵelement(10, "wg-icon", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(11, "div", 4);
          i0.ɵɵtemplate(12, DateTimePickerComponent_a_12_Template, 2, 3, "a", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(13, "div", 6);
          i0.ɵɵtemplate(14, DateTimePickerComponent_div_14_Template, 2, 1, "div", 7);
          i0.ɵɵelementStart(15, "h5");
          i0.ɵɵtext(16);
          i0.ɵɵpipe(17, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(18, "div", 8)(19, "label");
          i0.ɵɵtext(20);
          i0.ɵɵpipe(21, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(22, DateTimePickerComponent_wg_date_input_22_Template, 1, 2, "wg-date-input", 9)(23, DateTimePickerComponent_wg_date_input_23_Template, 1, 4, "wg-date-input", 10);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(24, DateTimePickerComponent_div_24_Template, 5, 4, "div", 7);
          i0.ɵɵelementStart(25, "h5");
          i0.ɵɵtext(26);
          i0.ɵɵpipe(27, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(28, "div", 8)(29, "label");
          i0.ɵɵtext(30);
          i0.ɵɵpipe(31, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(32, DateTimePickerComponent_wg_date_input_32_Template, 1, 3, "wg-date-input", 11)(33, DateTimePickerComponent_wg_date_input_33_Template, 1, 4, "wg-date-input", 10);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(34, DateTimePickerComponent_div_34_Template, 5, 4, "div", 7);
          i0.ɵɵelementStart(35, "div", 12)(36, "label")(37, "input", 13);
          i0.ɵɵtwoWayListener("ngModelChange", function DateTimePickerComponent_Template_input_ngModelChange_37_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.showTimes, $event) || (ctx.showTimes = $event);
            return $event;
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelement(38, "span", 14);
          i0.ɵɵpipe(39, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(40, "button", 15);
          i0.ɵɵlistener("click", function DateTimePickerComponent_Template_button_click_40_listener() {
            return ctx.saveCustom();
          });
          i0.ɵɵtext(41);
          i0.ɵɵpipe(42, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(43, "a", 16);
          i0.ɵɵlistener("click", function DateTimePickerComponent_Template_a_click_43_listener() {
            return ctx.cancelCustom();
          });
          i0.ɵɵtext(44);
          i0.ɵɵpipe(45, "translate");
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.isDisabled ? "color-watchguard-gray" : "");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 24, ctx.selectedPresetName));
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate(ctx.formattedDateString);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.isDisabled ? "color-watchguard-gray" : "");
          i0.ɵɵadvance();
          i0.ɵɵclassProp("show", ctx.showDropdown);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.presets);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("show", ctx.showCustom);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.customButtonItems == null ? null : ctx.customButtonItems.length);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 26, ctx.sharedStrings.from));
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 28, ctx.sharedStrings.date));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.minDate || !ctx.maxDate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.minDate && ctx.maxDate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showTimes);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(27, 30, ctx.sharedStrings.to));
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(31, 32, ctx.sharedStrings.date));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.maxDate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.maxDate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showTimes);
          i0.ɵɵadvance(3);
          i0.ɵɵtwoWayProperty("ngModel", ctx.showTimes);
          i0.ɵɵadvance();
          i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(39, 34, ctx.sharedStrings.show_time_note), i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(42, 36, ctx.sharedStrings.save));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(45, 38, ctx.sharedStrings.cancel));
        }
      },
      dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i1$1.CheckboxControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i4.WgIconComponent, i4.WgSelectButtonComponent, DateInputComponent, TimeInputComponent, i1.TranslatePipe],
      styles: ["wg-page-date-picker{overflow:visible;position:relative}wg-page-date-picker a.wg-page-date-picker,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex]){font-size:12px;font-size:.9230769231rem;align-items:center;color:#262626;display:inline-flex;line-height:34px;-webkit-user-select:none;user-select:none}wg-page-date-picker a.wg-page-date-picker>wg-icon,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>wg-icon{height:20px;line-height:0;width:20px}wg-page-date-picker a.wg-page-date-picker>wg-icon svg,wg-page-date-picker a.wg-page-date-picker>wg-icon svg path,wg-page-date-picker a.wg-page-date-picker>wg-icon svg circle,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>wg-icon svg,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>wg-icon svg path,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>wg-icon svg circle{fill:#367b88;stroke:transparent}wg-page-date-picker a.wg-page-date-picker>wg-icon svg,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>wg-icon svg{height:20px;min-height:20px;min-width:20px;width:20px}wg-page-date-picker a.wg-page-date-picker>wg-icon:nth-of-type(1),wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>wg-icon:nth-of-type(1){margin-right:8px}wg-page-date-picker a.wg-page-date-picker>wg-icon:nth-last-of-type(1),wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>wg-icon:nth-last-of-type(1){margin-left:5px}wg-page-date-picker a.wg-page-date-picker>div,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>div{display:inline-flex}wg-page-date-picker a.wg-page-date-picker>div .preset-name,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>div .preset-name{font-weight:700}wg-page-date-picker a.wg-page-date-picker>div span:nth-of-type(3),wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>div span:nth-of-type(3){font-size:11px;font-size:.8461538462rem;margin-left:5px}wg-page-date-picker a.wg-page-date-picker:hover,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex]):hover{text-decoration:none}wg-page-date-picker a.wg-page-date-picker:hover>wg-icon svg,wg-page-date-picker a.wg-page-date-picker:hover>wg-icon svg path,wg-page-date-picker a.wg-page-date-picker:hover>wg-icon svg circle,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex]):hover>wg-icon svg,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex]):hover>wg-icon svg path,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex]):hover>wg-icon svg circle{fill:#359db0;stroke:transparent}wg-page-date-picker .wg-page-date-picker-dropdown{background:#fff;box-shadow:0 2px 4px #0000004d;display:none;left:0;top:34px;overflow:visible;position:absolute;width:276px;z-index:9998}wg-page-date-picker .wg-page-date-picker-dropdown a{display:block;line-height:44px;padding:0 30px}wg-page-date-picker .wg-page-date-picker-dropdown.show{display:block}wg-page-date-picker .wg-page-date-picker-dropdown a,wg-page-date-picker .wg-page-date-picker-dropdown a:not([href]):not([tabindex]){color:#262626}wg-page-date-picker .wg-page-date-picker-dropdown a:hover,wg-page-date-picker .wg-page-date-picker-dropdown a.active,wg-page-date-picker .wg-page-date-picker-dropdown a:not([href]):not([tabindex]):hover,wg-page-date-picker .wg-page-date-picker-dropdown a:not([href]):not([tabindex]).active{background:#edf9fc;text-decoration:none}wg-page-date-picker .wg-page-date-picker-custom{background:#edf9fc;box-shadow:0 2px 4px #0000004d;display:none;left:276px;padding:30px;overflow:visible;position:absolute;top:34px;width:276px;z-index:9998}wg-page-date-picker .wg-page-date-picker-custom.show{display:block}wg-page-date-picker .wg-page-date-picker-custom h5{font-size:14px;font-weight:700;margin-bottom:15px;margin-top:50px;text-transform:uppercase}wg-page-date-picker .wg-page-date-picker-custom h5:nth-of-type(1){margin-top:0}wg-page-date-picker .wg-page-date-picker-custom .form-actions{margin-top:50px}wg-page-date-picker .wg-page-date-picker-custom .form-actions label{font-size:13px;font-size:1rem;margin-bottom:15px}wg-page-date-picker .wg-page-date-picker-custom .form-actions label input{margin-right:5px}wg-page-date-picker .wg-page-date-picker-custom .form-actions button{min-width:102px}wg-page-date-picker .wg-page-date-picker-custom .select-buttons label{font-size:10px;max-width:100%!important}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateTimePickerComponent, [{
    type: Component,
    args: [{
      encapsulation: ViewEncapsulation.None,
      selector: 'wg-page-date-picker',
      standalone: false,
      template: "<a class=\"wg-page-date-picker\" (click)=\"toggleDropdown()\">\n  <wg-icon name=\"calendar\" [ngClass]=\"isDisabled ? 'color-watchguard-gray' : ''\"></wg-icon>\n  <div>\n    <span class=\"preset-name\">{{ selectedPresetName | translate }}</span>\n    <span>:</span>\n    <span>{{ formattedDateString }}</span>\n  </div>\n  <wg-icon name=\"expanded\" [ngClass]=\"isDisabled ? 'color-watchguard-gray' : ''\"></wg-icon>\n</a>\n\n<div class=\"wg-page-date-picker-dropdown\" [class.show]=\"showDropdown\">\n  <a *ngFor=\"let preset of presets\" (click)=\"presetClick(preset)\" [class.active]=\"preset.isCustom && showCustom\">\n    <div class=\"d-flex justify-content-between\" *ngIf=\"preset.show || preset.show === undefined\">\n      <span [ngClass]=\"{ 'font-weight-bold': boldPresets }\">\n        {{ preset.label | translate }}\n      </span>\n      <span *ngIf=\"preset.isCustom && customButtonItems?.length\">\n        <wg-icon name=\"angle-right-filled\"></wg-icon>\n      </span>\n    </div>\n  </a>\n</div>\n\n<div class=\"wg-page-date-picker-custom\" [class.show]=\"showCustom\">\n  <div class=\"form-group\" *ngIf=\"customButtonItems?.length\">\n    <wg-select-button class=\"select-buttons\" [options]=\"customButtonItems\" (optionClick)=\"optionClicked($event)\"></wg-select-button>\n  </div>\n\n  <h5>{{ sharedStrings.from | translate }}</h5>\n\n  <div class=\"form-group\">\n    <label>{{ sharedStrings.date | translate }}</label>\n    <wg-date-input *ngIf=\"!minDate || !maxDate\" [dateFormat]=\"dateFormat\" [(ngModel)]=\"startDateString\" (change)=\"startDateChanged($event)\"></wg-date-input>\n    <wg-date-input *ngIf=\"minDate && maxDate\" [dateFormat]=\"dateFormat\" [(ngModel)]=\"startDateString\" [min]=\"minDate\" [max]=\"maxDate\" (change)=\"startDateChanged($event)\"></wg-date-input>\n  </div>\n\n  <div class=\"form-group\" *ngIf=\"showTimes\">\n    <label>{{ sharedStrings.time | translate }}</label>\n    <wg-time-input [(ngModel)]=\"startTime\"></wg-time-input>\n  </div>\n\n  <h5>{{ sharedStrings.to | translate }}</h5>\n\n  <div class=\"form-group\">\n    <label>{{ sharedStrings.date | translate }}</label>\n    <wg-date-input *ngIf=\"!maxDate\" [dateFormat]=\"dateFormat\" [(ngModel)]=\"endDateString\" [min]=\"startDate\" (change)=\"endDateChanged($event)\"></wg-date-input>\n    <wg-date-input *ngIf=\"maxDate\" [dateFormat]=\"dateFormat\" [(ngModel)]=\"endDateString\" [min]=\"startDate\" [max]=\"maxDate\" (change)=\"endDateChanged($event)\"></wg-date-input>\n  </div>\n\n  <div class=\"form-group\" *ngIf=\"showTimes\">\n    <label>{{ sharedStrings.time | translate }}</label>\n    <wg-time-input [(ngModel)]=\"endTime\"></wg-time-input>\n  </div>\n\n  <div class=\"form-actions column\">\n    <label><input type=\"checkbox\" [(ngModel)]=\"showTimes\"> <span [innerHTML]=\"sharedStrings.show_time_note | translate\"></span></label>\n    <button type=\"button\" class=\"btn btn-primary\" (click)=\"saveCustom()\">{{ sharedStrings.save | translate }}</button>\n    <a (click)=\"cancelCustom()\">{{ sharedStrings.cancel | translate }}</a>\n  </div>\n</div>\n",
      styles: ["wg-page-date-picker{overflow:visible;position:relative}wg-page-date-picker a.wg-page-date-picker,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex]){font-size:12px;font-size:.9230769231rem;align-items:center;color:#262626;display:inline-flex;line-height:34px;-webkit-user-select:none;user-select:none}wg-page-date-picker a.wg-page-date-picker>wg-icon,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>wg-icon{height:20px;line-height:0;width:20px}wg-page-date-picker a.wg-page-date-picker>wg-icon svg,wg-page-date-picker a.wg-page-date-picker>wg-icon svg path,wg-page-date-picker a.wg-page-date-picker>wg-icon svg circle,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>wg-icon svg,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>wg-icon svg path,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>wg-icon svg circle{fill:#367b88;stroke:transparent}wg-page-date-picker a.wg-page-date-picker>wg-icon svg,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>wg-icon svg{height:20px;min-height:20px;min-width:20px;width:20px}wg-page-date-picker a.wg-page-date-picker>wg-icon:nth-of-type(1),wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>wg-icon:nth-of-type(1){margin-right:8px}wg-page-date-picker a.wg-page-date-picker>wg-icon:nth-last-of-type(1),wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>wg-icon:nth-last-of-type(1){margin-left:5px}wg-page-date-picker a.wg-page-date-picker>div,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>div{display:inline-flex}wg-page-date-picker a.wg-page-date-picker>div .preset-name,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>div .preset-name{font-weight:700}wg-page-date-picker a.wg-page-date-picker>div span:nth-of-type(3),wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex])>div span:nth-of-type(3){font-size:11px;font-size:.8461538462rem;margin-left:5px}wg-page-date-picker a.wg-page-date-picker:hover,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex]):hover{text-decoration:none}wg-page-date-picker a.wg-page-date-picker:hover>wg-icon svg,wg-page-date-picker a.wg-page-date-picker:hover>wg-icon svg path,wg-page-date-picker a.wg-page-date-picker:hover>wg-icon svg circle,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex]):hover>wg-icon svg,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex]):hover>wg-icon svg path,wg-page-date-picker a.wg-page-date-picker:not([href]):not([tabindex]):hover>wg-icon svg circle{fill:#359db0;stroke:transparent}wg-page-date-picker .wg-page-date-picker-dropdown{background:#fff;box-shadow:0 2px 4px #0000004d;display:none;left:0;top:34px;overflow:visible;position:absolute;width:276px;z-index:9998}wg-page-date-picker .wg-page-date-picker-dropdown a{display:block;line-height:44px;padding:0 30px}wg-page-date-picker .wg-page-date-picker-dropdown.show{display:block}wg-page-date-picker .wg-page-date-picker-dropdown a,wg-page-date-picker .wg-page-date-picker-dropdown a:not([href]):not([tabindex]){color:#262626}wg-page-date-picker .wg-page-date-picker-dropdown a:hover,wg-page-date-picker .wg-page-date-picker-dropdown a.active,wg-page-date-picker .wg-page-date-picker-dropdown a:not([href]):not([tabindex]):hover,wg-page-date-picker .wg-page-date-picker-dropdown a:not([href]):not([tabindex]).active{background:#edf9fc;text-decoration:none}wg-page-date-picker .wg-page-date-picker-custom{background:#edf9fc;box-shadow:0 2px 4px #0000004d;display:none;left:276px;padding:30px;overflow:visible;position:absolute;top:34px;width:276px;z-index:9998}wg-page-date-picker .wg-page-date-picker-custom.show{display:block}wg-page-date-picker .wg-page-date-picker-custom h5{font-size:14px;font-weight:700;margin-bottom:15px;margin-top:50px;text-transform:uppercase}wg-page-date-picker .wg-page-date-picker-custom h5:nth-of-type(1){margin-top:0}wg-page-date-picker .wg-page-date-picker-custom .form-actions{margin-top:50px}wg-page-date-picker .wg-page-date-picker-custom .form-actions label{font-size:13px;font-size:1rem;margin-bottom:15px}wg-page-date-picker .wg-page-date-picker-custom .form-actions label input{margin-right:5px}wg-page-date-picker .wg-page-date-picker-custom .form-actions button{min-width:102px}wg-page-date-picker .wg-page-date-picker-custom .select-buttons label{font-size:10px;max-width:100%!important}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i1.TranslateService
  }], {
    hideCalenderPresets: [{
      type: Input
    }],
    customButtonItems: [{
      type: Input
    }],
    customPresets: [{
      type: Input
    }],
    startDateTime: [{
      type: Input
    }],
    endDateTime: [{
      type: Input
    }],
    presetUserSelection: [{
      type: Input
    }],
    presetOrder: [{
      type: Input
    }],
    isDisabled: [{
      type: Input
    }],
    boldPresets: [{
      type: Input
    }],
    minDate: [{
      type: Input
    }],
    maxDate: [{
      type: Input
    }],
    startDateTimeChange: [{
      type: Output
    }],
    endDateTimeChange: [{
      type: Output
    }],
    dateTimeChange: [{
      type: Output
    }],
    clickout: [{
      type: HostListener,
      args: ['document:click', ['$event']]
    }]
  });
})();

/**
 * This component code was mostly lifted from the open source PrimeFaces slider
 * primeng version: 13.0.4
 * source: https://github.com/primefaces/primeng/blob/13.0.4/src/app/components/slider/slider.ts
 */
const SLIDER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => WgSliderComponent),
  multi: true
};
class WgSliderComponent {
  constructor(el, renderer, ngZone, cd) {
    this.el = el;
    this.renderer = renderer;
    this.ngZone = ngZone;
    this.cd = cd;
    this.min = 0;
    this.max = 100;
    this.orientation = 'horizontal';
    this.tabindex = 0;
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    this.onChange = new EventEmitter();
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    this.onSlideEnd = new EventEmitter();
    this.handleValues = [];
    this.onModelChange = () => {};
    this.onModelTouched = () => {};
    this.handleIndex = 0;
  }
  onMouseDown(event, index) {
    if (this.disabled) {
      return;
    }
    this.dragging = true;
    this.updateDomData();
    this.sliderHandleClick = true;
    if (this.range && this.handleValues && this.handleValues[0] === this.max) {
      this.handleIndex = 0;
    } else {
      this.handleIndex = index;
    }
    this.bindDragListeners();
    event.target.focus();
    event.preventDefault();
    if (this.animate) {
      DomHandler.removeClass(this.el.nativeElement.children[0], 'p-slider-animate');
    }
  }
  onTouchStart(event, index) {
    if (this.disabled) {
      return;
    }
    var touchobj = event.changedTouches[0];
    this.startHandleValue = this.range ? this.handleValues[index] : this.handleValue;
    this.dragging = true;
    if (this.range && this.handleValues && this.handleValues[0] === this.max) {
      this.handleIndex = 0;
    } else {
      this.handleIndex = index;
    }
    if (this.orientation === 'horizontal') {
      this.startx = parseInt(touchobj.clientX, 10);
      this.barWidth = this.el.nativeElement.children[0].offsetWidth;
    } else {
      this.starty = parseInt(touchobj.clientY, 10);
      this.barHeight = this.el.nativeElement.children[0].offsetHeight;
    }
    if (this.animate) {
      DomHandler.removeClass(this.el.nativeElement.children[0], 'p-slider-animate');
    }
    event.preventDefault();
  }
  onTouchMove(event, index) {
    if (this.disabled) {
      return;
    }
    var touchobj = event.changedTouches[0],
      handleValue = 0;
    if (this.orientation === 'horizontal') {
      handleValue = Math.floor((parseInt(touchobj.clientX, 10) - this.startx) * 100 / this.barWidth) + this.startHandleValue;
    } else {
      handleValue = Math.floor((this.starty - parseInt(touchobj.clientY, 10)) * 100 / this.barHeight) + this.startHandleValue;
    }
    this.setValueFromHandle(event, handleValue);
    event.preventDefault();
  }
  onTouchEnd(event, index) {
    if (this.disabled) {
      return;
    }
    this.dragging = false;
    if (this.range) this.onSlideEnd.emit({
      originalEvent: event,
      values: this.values
    });else this.onSlideEnd.emit({
      originalEvent: event,
      value: this.value
    });
    if (this.animate) {
      DomHandler.addClass(this.el.nativeElement.children[0], 'p-slider-animate');
    }
    event.preventDefault();
  }
  onBarClick(event) {
    if (this.disabled) {
      return;
    }
    if (!this.sliderHandleClick) {
      this.updateDomData();
      this.handleChange(event);
    }
    this.sliderHandleClick = false;
  }
  onHandleKeydown(event, handleIndex) {
    if (this.disabled) {
      return;
    }
    if (event.which == 38 || event.which == 39) {
      this.spin(event, 1, handleIndex);
    } else if (event.which == 37 || event.which == 40) {
      this.spin(event, -1, handleIndex);
    }
  }
  spin(event, dir, handleIndex) {
    let step = (this.step || 1) * dir;
    if (this.range) {
      this.handleIndex = handleIndex;
      this.updateValue(this.values[this.handleIndex] + step);
      this.updateHandleValue();
    } else {
      this.updateValue(this.value + step);
      this.updateHandleValue();
    }
    event.preventDefault();
  }
  handleChange(event) {
    let handleValue = this.calculateHandleValue(event);
    this.setValueFromHandle(event, handleValue);
  }
  bindDragListeners() {
    this.ngZone.runOutsideAngular(() => {
      const documentTarget = this.el ? this.el.nativeElement.ownerDocument : 'document';
      if (!this.dragListener) {
        this.dragListener = this.renderer.listen(documentTarget, 'mousemove', event => {
          if (this.dragging) {
            this.ngZone.run(() => {
              this.handleChange(event);
            });
          }
        });
      }
      if (!this.mouseupListener) {
        this.mouseupListener = this.renderer.listen(documentTarget, 'mouseup', event => {
          if (this.dragging) {
            this.dragging = false;
            this.ngZone.run(() => {
              if (this.range) this.onSlideEnd.emit({
                originalEvent: event,
                values: this.values
              });else this.onSlideEnd.emit({
                originalEvent: event,
                value: this.value
              });
              if (this.animate) {
                DomHandler.addClass(this.el.nativeElement.children[0], 'p-slider-animate');
              }
            });
          }
        });
      }
    });
  }
  unbindDragListeners() {
    if (this.dragListener) {
      this.dragListener();
    }
    if (this.mouseupListener) {
      this.mouseupListener();
    }
  }
  setValueFromHandle(event, handleValue) {
    this.sliderHandleClick = false;
    let newValue = this.getValueFromHandle(handleValue);
    if (this.range) {
      if (this.step) {
        this.handleStepChange(newValue, this.values[this.handleIndex]);
      } else {
        this.handleValues[this.handleIndex] = handleValue;
        this.updateValue(newValue, event);
      }
    } else {
      if (this.step) {
        this.handleStepChange(newValue, this.value);
      } else {
        this.handleValue = handleValue;
        this.updateValue(newValue, event);
      }
    }
    this.cd.markForCheck();
  }
  handleStepChange(newValue, oldValue) {
    let diff = newValue - oldValue;
    let val = oldValue;
    if (diff < 0) {
      val = oldValue + Math.ceil(newValue / this.step - oldValue / this.step) * this.step;
    } else if (diff > 0) {
      val = oldValue + Math.floor(newValue / this.step - oldValue / this.step) * this.step;
    }
    this.updateValue(val);
    this.updateHandleValue();
  }
  writeValue(value) {
    if (this.range) this.values = value || [0, 0];else this.value = value || 0;
    this.updateHandleValue();
    this.cd.markForCheck();
  }
  registerOnChange(fn) {
    this.onModelChange = fn;
  }
  registerOnTouched(fn) {
    this.onModelTouched = fn;
  }
  setDisabledState(val) {
    this.disabled = val;
    this.cd.markForCheck();
  }
  get rangeStartLeft() {
    return this.isVertical() ? 'auto' : this.handleValues[0] + '%';
  }
  get rangeStartBottom() {
    return this.isVertical() ? this.handleValues[0] + '%' : 'auto';
  }
  get rangeEndLeft() {
    return this.isVertical() ? 'auto' : this.handleValues[1] + '%';
  }
  get rangeEndBottom() {
    return this.isVertical() ? this.handleValues[1] + '%' : 'auto';
  }
  isVertical() {
    return this.orientation === 'vertical';
  }
  updateDomData() {
    let rect = this.el.nativeElement.children[0].getBoundingClientRect();
    this.initX = rect.left + DomHandler.getWindowScrollLeft();
    this.initY = rect.top + DomHandler.getWindowScrollTop();
    this.barWidth = this.el.nativeElement.children[0].offsetWidth;
    this.barHeight = this.el.nativeElement.children[0].offsetHeight;
  }
  calculateHandleValue(event) {
    if (this.orientation === 'horizontal') return (event.pageX - this.initX) * 100 / this.barWidth;else return (this.initY + this.barHeight - event.pageY) * 100 / this.barHeight;
  }
  updateHandleValue() {
    if (this.range) {
      this.handleValues[0] = (this.values[0] < this.min ? 0 : this.values[0] - this.min) * 100 / (this.max - this.min);
      this.handleValues[1] = (this.values[1] > this.max ? 100 : this.values[1] - this.min) * 100 / (this.max - this.min);
    } else {
      if (this.value < this.min) this.handleValue = 0;else if (this.value > this.max) this.handleValue = 100;else this.handleValue = (this.value - this.min) * 100 / (this.max - this.min);
    }
  }
  updateValue(val, event) {
    if (this.range) {
      let value = val;
      if (this.handleIndex == 0) {
        if (value < this.min) {
          value = this.min;
          this.handleValues[0] = 0;
        } else if (value > this.values[1]) {
          value = this.values[1];
          this.handleValues[0] = this.handleValues[1];
        }
        this.sliderHandleStart.nativeElement.focus();
      } else {
        if (value > this.max) {
          value = this.max;
          this.handleValues[1] = 100;
        } else if (value < this.values[0]) {
          value = this.values[0];
          this.handleValues[1] = this.handleValues[0];
        }
        this.sliderHandleEnd.nativeElement.focus();
      }
      this.values[this.handleIndex] = this.getNormalizedValue(value);
      this.values = this.values.slice();
      this.onModelChange(this.values);
      this.onChange.emit({
        event: event,
        values: this.values
      });
    } else {
      if (val < this.min) {
        val = this.min;
        this.handleValue = 0;
      } else if (val > this.max) {
        val = this.max;
        this.handleValue = 100;
      }
      this.value = this.getNormalizedValue(val);
      this.onModelChange(this.value);
      this.onChange.emit({
        event: event,
        value: this.value
      });
      this.sliderHandle.nativeElement.focus();
    }
  }
  getValueFromHandle(handleValue) {
    return (this.max - this.min) * (handleValue / 100) + this.min;
  }
  getDecimalsCount(value) {
    if (value && Math.floor(value) !== value) return value.toString().split(".")[1].length || 0;
    return 0;
  }
  getNormalizedValue(val) {
    let decimalsCount = this.getDecimalsCount(this.step);
    if (decimalsCount > 0) {
      return +val.toFixed(decimalsCount);
    } else {
      return Math.floor(val);
    }
  }
  ngOnDestroy() {
    this.unbindDragListeners();
  }
  static {
    this.ɵfac = function WgSliderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgSliderComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgSliderComponent,
      selectors: [["wg-slider"]],
      viewQuery: function WgSliderComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c1, 5);
          i0.ɵɵviewQuery(_c2, 5);
          i0.ɵɵviewQuery(_c3, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sliderHandle = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sliderHandleStart = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sliderHandleEnd = _t.first);
        }
      },
      hostAttrs: [1, "p-element"],
      inputs: {
        animate: "animate",
        disabled: "disabled",
        min: "min",
        max: "max",
        orientation: "orientation",
        step: "step",
        range: "range",
        style: "style",
        styleClass: "styleClass",
        ariaLabelledBy: "ariaLabelledBy",
        tabindex: "tabindex"
      },
      outputs: {
        onChange: "onChange",
        onSlideEnd: "onSlideEnd"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([SLIDER_VALUE_ACCESSOR])],
      decls: 8,
      vars: 16,
      consts: [["sliderHandle", ""], ["sliderHandleStart", ""], ["sliderHandleEnd", ""], [3, "click", "ngStyle", "ngClass"], ["class", "p-slider-range", 3, "ngStyle", 4, "ngIf"], ["class", "p-slider-handle", 3, "transition", "ngStyle", "keydown", "mousedown", "touchstart", "touchmove", "touchend", 4, "ngIf"], ["class", "p-slider-handle", 3, "transition", "ngStyle", "ngClass", "keydown", "mousedown", "touchstart", "touchmove", "touchend", 4, "ngIf"], [1, "p-slider-range", 3, "ngStyle"], [1, "p-slider-handle", 3, "keydown", "mousedown", "touchstart", "touchmove", "touchend", "ngStyle"], [1, "p-slider-handle", 3, "keydown", "mousedown", "touchstart", "touchmove", "touchend", "ngStyle", "ngClass"]],
      template: function WgSliderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 3);
          i0.ɵɵlistener("click", function WgSliderComponent_Template_div_click_0_listener($event) {
            return ctx.onBarClick($event);
          });
          i0.ɵɵtemplate(1, WgSliderComponent_span_1_Template, 1, 4, "span", 4)(2, WgSliderComponent_span_2_Template, 1, 4, "span", 4)(3, WgSliderComponent_span_3_Template, 1, 3, "span", 4)(4, WgSliderComponent_span_4_Template, 1, 3, "span", 4)(5, WgSliderComponent_span_5_Template, 2, 11, "span", 5)(6, WgSliderComponent_span_6_Template, 2, 14, "span", 6)(7, WgSliderComponent_span_7_Template, 2, 14, "span", 6);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.styleClass);
          i0.ɵɵproperty("ngStyle", ctx.style)("ngClass", i0.ɵɵpureFunction4(11, _c4, ctx.disabled, ctx.orientation === "horizontal", ctx.orientation === "vertical", ctx.animate));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.range && ctx.orientation === "horizontal");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.range && ctx.orientation === "vertical");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.range && ctx.orientation === "vertical");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.range && ctx.orientation === "horizontal");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.range);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.range);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.range);
        }
      },
      dependencies: [i2.NgClass, i2.NgIf, i2.NgStyle],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgSliderComponent, [{
    type: Component,
    args: [{
      selector: 'wg-slider',
      template: `
    <div [ngStyle]="style" [class]="styleClass" [ngClass]="{'p-slider p-component':true,'p-disabled':disabled,
      'p-slider-horizontal':orientation === 'horizontal','p-slider-vertical':orientation === 'vertical','p-slider-animate':animate}"
      (click)="onBarClick($event)">
      <span *ngIf="range && orientation === 'horizontal'" class="p-slider-range" [ngStyle]="{'left':handleValues[0] + '%',width: (handleValues[1] - handleValues[0] + '%')}"></span>
      <span *ngIf="range && orientation === 'vertical'" class="p-slider-range" [ngStyle]="{'bottom':handleValues[0] + '%',height: (handleValues[1] - handleValues[0] + '%')}"></span>
      <span *ngIf="!range && orientation === 'vertical'" class="p-slider-range" [ngStyle]="{'height': handleValue + '%'}"></span>
      <span *ngIf="!range && orientation === 'horizontal'" class="p-slider-range" [ngStyle]="{'width': handleValue + '%'}"></span>
      <span #sliderHandle *ngIf="!range" [attr.tabindex]="disabled ? null : tabindex" (keydown)="onHandleKeydown($event)" class="p-slider-handle" (mousedown)="onMouseDown($event)" (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)"
        [style.transition]="dragging ? 'none': null" [ngStyle]="{'left': orientation === 'horizontal' ? handleValue + '%' : null,'bottom': orientation === 'vertical' ? handleValue + '%' : null}"
        [attr.aria-valuemin]="min" [attr.aria-valuenow]="value" [attr.aria-valuemax]="max" [attr.aria-labelledby]="ariaLabelledBy"></span>
      <span #sliderHandleStart *ngIf="range" [attr.tabindex]="disabled ? null : tabindex" (keydown)="onHandleKeydown($event,0)" (mousedown)="onMouseDown($event,0)" (touchstart)="onTouchStart($event,0)" (touchmove)="onTouchMove($event,0)" (touchend)="onTouchEnd($event)" [style.transition]="dragging ? 'none': null" class="p-slider-handle"
        [ngStyle]="{'left': rangeStartLeft, 'bottom': rangeStartBottom}" [ngClass]="{'p-slider-handle-active':handleIndex===0}"
        [attr.aria-valuemin]="min" [attr.aria-valuenow]="value ? value[0] : null" [attr.aria-valuemax]="max" [attr.aria-labelledby]="ariaLabelledBy"></span>
      <span #sliderHandleEnd *ngIf="range" [attr.tabindex]="disabled ? null : tabindex" (keydown)="onHandleKeydown($event,1)" (mousedown)="onMouseDown($event,1)" (touchstart)="onTouchStart($event,1)" (touchmove)="onTouchMove($event,1)" (touchend)="onTouchEnd($event)" [style.transition]="dragging ? 'none': null" class="p-slider-handle"
        [ngStyle]="{'left': rangeEndLeft, 'bottom': rangeEndBottom}" [ngClass]="{'p-slider-handle-active':handleIndex===1}"
        [attr.aria-valuemin]="min" [attr.aria-valuenow]="value ? value[1] : null" [attr.aria-valuemax]="max" [attr.aria-labelledby]="ariaLabelledBy"></span>
    </div>
  `,
      providers: [SLIDER_VALUE_ACCESSOR],
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      // eslint-disable-next-line @angular-eslint/no-host-metadata-property
      host: {
        'class': 'p-element'
      },
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }, {
    type: i0.NgZone
  }, {
    type: i0.ChangeDetectorRef
  }], {
    animate: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    max: [{
      type: Input
    }],
    orientation: [{
      type: Input
    }],
    step: [{
      type: Input
    }],
    range: [{
      type: Input
    }],
    style: [{
      type: Input
    }],
    styleClass: [{
      type: Input
    }],
    ariaLabelledBy: [{
      type: Input
    }],
    tabindex: [{
      type: Input
    }],
    onChange: [{
      type: Output
    }],
    onSlideEnd: [{
      type: Output
    }],
    sliderHandle: [{
      type: ViewChild,
      args: ["sliderHandle"]
    }],
    sliderHandleStart: [{
      type: ViewChild,
      args: ["sliderHandleStart"]
    }],
    sliderHandleEnd: [{
      type: ViewChild,
      args: ["sliderHandleEnd"]
    }]
  });
})();
const SHOW_ODD_NUMBERS_WIDTH = 1440;
class DayTimeRangeComponent {
  constructor(elementRef, globalEventService) {
    this.elementRef = elementRef;
    this.globalEventService = globalEventService;
    this.showOddNumbers = false;
    this.disabled = false;
    this.rangeEntriesChange = new EventEmitter();
    this.increment = 0.5;
    this.numbers = [...Array(25).keys()];
  }
  ngOnChanges(changes) {
    if (changes.rangeEntries) {
      this.updateRangeEntries();
    }
  }
  ngOnDestroy() {
    if (this.windowResized$) {
      this.windowResized$.unsubscribe();
    }
  }
  ngOnInit() {
    this.windowResized$ = this.globalEventService.windowResized.subscribe(event => {
      if (this.elementRef.nativeElement.offsetWidth > SHOW_ODD_NUMBERS_WIDTH) {
        this.showOddNumbers = true;
      } else {
        this.showOddNumbers = false;
      }
    });
    this.updateRangeEntries();
  }
  rangeChange(rangeEntry, emitChangeEvent = true) {
    if (rangeEntry.values[0] === rangeEntry.values[1]) {
      if (rangeEntry.values[0] !== rangeEntry.previousValues[0]) {
        rangeEntry.values[0] = rangeEntry.values[0] - 0.5;
      } else {
        rangeEntry.values[1] = rangeEntry.values[1] + 0.5;
      }
    }
    this.formatRangeEntry(rangeEntry);
    rangeEntry.previousValues = [rangeEntry.values[0], rangeEntry.values[1]];
    if (emitChangeEvent) {
      this.rangeEntriesChange.emit(this.rangeEntries);
    }
  }
  rangeCheckInput() {
    setTimeout(() => {
      this.rangeEntriesChange.emit(this.rangeEntries);
    });
  }
  formatRangeEntry(rangeEntry) {
    if (!rangeEntry) {
      return;
    }
    rangeEntry.formattedValues = [];
    for (let index = 0; index < 2; index++) {
      if (rangeEntry.values && rangeEntry.values.length > index) {
        let formattedValue = rangeEntry.values[index].toLocaleString();
        if (parseInt(formattedValue, 10) < 10) {
          formattedValue = '0' + formattedValue;
        }
        if (formattedValue.endsWith('.5')) {
          formattedValue = formattedValue.substring(0, formattedValue.indexOf('.')) + ':30';
        } else {
          formattedValue = formattedValue + ':00';
        }
        rangeEntry.formattedValues.push(formattedValue);
      }
    }
  }
  updateRangeEntries() {
    if (this.rangeEntries && this.rangeEntries.length > 0) {
      this.rangeEntries.forEach(rangeEntry => this.rangeChange(rangeEntry, false));
    }
  }
  static {
    this.ɵfac = function DayTimeRangeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DayTimeRangeComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i4.GlobalEventService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DayTimeRangeComponent,
      selectors: [["wg-day-time-range"]],
      hostVars: 2,
      hostBindings: function DayTimeRangeComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("show-odd-numbers", ctx.showOddNumbers);
        }
      },
      inputs: {
        disabled: "disabled",
        rangeEntries: "rangeEntries"
      },
      outputs: {
        rangeEntriesChange: "rangeEntriesChange"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 1,
      vars: 1,
      consts: [[4, "ngFor", "ngForOf"], [1, "form-group", "for-checkbox"], [1, "form-check"], [1, "form-check-label"], ["type", "checkbox", 1, "form-check-input", 3, "ngModelChange", "input", "ngModel", "disabled"], [4, "ngIf"], [1, "range"], [1, "list-unstyled", "numbers"], [3, "ngModelChange", "onChange", "ngModel", "range", "min", "max", "step", "disabled"]],
      template: function DayTimeRangeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, DayTimeRangeComponent_div_0_Template, 14, 11, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngForOf", ctx.rangeEntries);
        }
      },
      dependencies: [i2.NgForOf, i2.NgIf, i1$1.CheckboxControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, WgSliderComponent],
      styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%] > div[_ngcontent-%COMP%]{align-items:center;display:flex;margin-top:10px}[_nghost-%COMP%] > div[_ngcontent-%COMP%]:nth-child(1){margin-top:0}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(1){margin-right:30px;white-space:nowrap;width:130px}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(1)   .form-group[_ngcontent-%COMP%]{margin-bottom:0!important}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(1)   .form-group.for-checkbox[_ngcontent-%COMP%]   .form-check[_ngcontent-%COMP%] > label[_ngcontent-%COMP%]{margin-bottom:0}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(2){margin-right:30px;white-space:nowrap;width:100px}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(3){flex-grow:1;margin:0 7px}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(3)   .range[_ngcontent-%COMP%]{height:32px}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(3)   .range[_ngcontent-%COMP%] > ul.numbers[_ngcontent-%COMP%]{display:flex;justify-content:space-between;margin:0 -7px;-webkit-user-select:none;user-select:none}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(3)   .range[_ngcontent-%COMP%] > ul.numbers[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{font-size:11px;line-height:1;position:relative;text-align:center;width:15px}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(3)   .range[_ngcontent-%COMP%] > ul.numbers[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:after{background:#d4d4d4;bottom:0;content:\" \";display:block;height:4px;left:calc(50% - .5px);position:absolute;width:1px}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(3)   .range[_ngcontent-%COMP%] > ul.numbers[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;margin-bottom:10px}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(3)   .range[_ngcontent-%COMP%] > ul.numbers[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:nth-child(2n)   span[_ngcontent-%COMP%]{visibility:hidden}.show-odd-numbers[_nghost-%COMP%] > div[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(3)   .range[_ngcontent-%COMP%] > ul.numbers[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:nth-child(2n)   span[_ngcontent-%COMP%]{visibility:visible}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DayTimeRangeComponent, [{
    type: Component,
    args: [{
      selector: 'wg-day-time-range',
      standalone: false,
      template: "<div *ngFor=\"let entry of rangeEntries\">\n  <div>\n    <div class=\"form-group for-checkbox\">\n      <div class=\"form-check\">\n        <label class=\"form-check-label\">\n          <input type=\"checkbox\"\n                 class=\"form-check-input\"\n                 [(ngModel)]=\"entry.checked\"\n                 (input)=\"rangeCheckInput()\"\n                 [disabled]=\"disabled\"> {{ entry.label }}\n        </label>\n      </div>\n    </div>\n  </div>\n  <div>\n    <ng-container *ngIf=\"entry.formattedValues\">\n      {{ entry.formattedValues[0] }}-{{ entry.formattedValues[1] }}\n    </ng-container>\n  </div>\n  <div>\n    <div class=\"range\">\n      <ul class=\"list-unstyled numbers\">\n        <li *ngFor=\"let number of numbers\"><span>{{ number }}</span></li>\n      </ul>\n\n      <wg-slider [(ngModel)]=\"entry.values\"\n          [range]=\"true\"\n          [min]=\"0\"\n          [max]=\"24\"\n          [step]=\"0.5\"\n          [disabled]=\"!entry.checked || disabled\"\n          (onChange)=\"rangeChange(entry)\"></wg-slider>\n    </div>\n  </div>\n</div>\n\n",
      styles: [":host{display:block}:host>div{align-items:center;display:flex;margin-top:10px}:host>div:nth-child(1){margin-top:0}:host>div>div:nth-child(1){margin-right:30px;white-space:nowrap;width:130px}:host>div>div:nth-child(1) .form-group{margin-bottom:0!important}:host>div>div:nth-child(1) .form-group.for-checkbox .form-check>label{margin-bottom:0}:host>div>div:nth-child(2){margin-right:30px;white-space:nowrap;width:100px}:host>div>div:nth-child(3){flex-grow:1;margin:0 7px}:host>div>div:nth-child(3) .range{height:32px}:host>div>div:nth-child(3) .range>ul.numbers{display:flex;justify-content:space-between;margin:0 -7px;-webkit-user-select:none;user-select:none}:host>div>div:nth-child(3) .range>ul.numbers>li{font-size:11px;line-height:1;position:relative;text-align:center;width:15px}:host>div>div:nth-child(3) .range>ul.numbers>li:after{background:#d4d4d4;bottom:0;content:\" \";display:block;height:4px;left:calc(50% - .5px);position:absolute;width:1px}:host>div>div:nth-child(3) .range>ul.numbers>li span{display:inline-block;margin-bottom:10px}:host>div>div:nth-child(3) .range>ul.numbers>li:nth-child(2n) span{visibility:hidden}:host.show-odd-numbers>div>div:nth-child(3) .range>ul.numbers>li:nth-child(2n) span{visibility:visible}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i4.GlobalEventService
  }], {
    showOddNumbers: [{
      type: HostBinding,
      args: ['class.show-odd-numbers']
    }],
    disabled: [{
      type: Input
    }],
    rangeEntries: [{
      type: Input
    }],
    rangeEntriesChange: [{
      type: Output
    }]
  });
})();
class DurationInputComponent {
  constructor(ngControl, translate, fb) {
    this.ngControl = ngControl;
    this.translate = translate;
    this.fb = fb;
    this.scales = 'smhd';
    this.subscriptions = [];
    this.timeScales = [];
    this.onChange = () => {};
    this.onTouched = () => {};
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }
  ngOnInit() {
    this.timeScales = [];
    if (this.scales.indexOf('s') !== -1) {
      this.timeScales.push({
        id: 'sec',
        val: this.translate.instant(SHARED_STRINGS.seconds),
        multiplier: 1
      });
    }
    if (this.scales.indexOf('m') !== -1) {
      this.timeScales.push({
        id: 'min',
        val: this.translate.instant(SHARED_STRINGS.minutes),
        multiplier: 60
      });
    }
    if (this.scales.indexOf('h') !== -1) {
      this.timeScales.push({
        id: 'hour',
        val: this.translate.instant(SHARED_STRINGS.hours),
        multiplier: 3600
      });
    }
    if (this.scales.indexOf('d') !== -1) {
      this.timeScales.push({
        id: 'day',
        val: this.translate.instant(SHARED_STRINGS.days),
        multiplier: 86400
      });
    }
    this.form = this.fb.group({
      timeScale: [this.timeScales[0]],
      time: [0]
    });
    this.subscriptions = this.subscriptions.concat([this.form.get('timeScale').valueChanges.subscribe(value => {
      const time = this.form.get('time').value;
      const seconds = Math.floor(value.multiplier * time);
      this.onChange(seconds);
      this.onTouched();
    }), this.form.get('time').valueChanges.subscribe(value => {
      const timeScale = this.form.get('timeScale').value;
      const seconds = Math.floor(timeScale.multiplier * value);
      this.onChange(seconds);
      this.onTouched();
    })]);
    this.writeValue(this._value);
  }
  ngAfterViewInit() {
    // FormControl should be available here
    const control = this.ngControl && this.ngControl.control;
    if (control) {
      const tCtrl = this.form.get('time');
      this.subscriptions = this.subscriptions.concat([control.statusChanges.subscribe(status => {
        switch (status) {
          case 'VALID':
          case 'INVALID':
            tCtrl.setErrors(control.errors);
            break;
        }
      })]);
    }
  }
  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.forEach(s => s.unsubscribe());
    }
    this.subscriptions = [];
  }
  findLargestTimeScale(seconds) {
    if (seconds < 0) {
      return this.timeScales[0];
    }
    const tsOption = this.timeScales.map(x => x).reverse().find(x => {
      return seconds % x.multiplier === 0;
    });
    return tsOption;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  writeValue(value) {
    this._value = value;
    if (this.form) {
      const timeCtrl = this.form.get('time');
      const timeScale = this.form.get('timeScale');
      const tsOption = this.findLargestTimeScale(value);
      timeCtrl.setValue(value / tsOption.multiplier);
      timeScale.setValue(tsOption);
    }
  }
  setDisabledState(isDisabled) {
    if (this.form) {
      if (isDisabled) {
        this.form.disable();
      } else {
        this.form.enable();
      }
    }
  }
  static {
    this.ɵfac = function DurationInputComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DurationInputComponent)(i0.ɵɵdirectiveInject(i1$1.NgControl, 10), i0.ɵɵdirectiveInject(i1.TranslateService), i0.ɵɵdirectiveInject(i1$1.UntypedFormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DurationInputComponent,
      selectors: [["wg-duration-input"]],
      inputs: {
        scales: "scales"
      },
      standalone: false,
      ngContentSelectors: _c11,
      decls: 1,
      vars: 1,
      consts: [["class", "form-group form-inline", 3, "formGroup", 4, "ngIf"], [1, "form-group", "form-inline", 3, "formGroup"], ["type", "number", "formControlName", "time", 1, "form-control"], ["formControlName", "timeScale", 3, "dropdownList"]],
      template: function DurationInputComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, DurationInputComponent_div_0_Template, 4, 2, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.form);
        }
      },
      dependencies: [i2.NgIf, i1$1.DefaultValueAccessor, i1$1.NumberValueAccessor, i1$1.NgControlStatus, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i1$1.FormControlName, i4.WgDropdownComponent],
      styles: ["input[type=number][_ngcontent-%COMP%]{min-width:0;width:120px;margin-right:5px}wg-dropdown[_ngcontent-%COMP%]{width:150px}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DurationInputComponent, [{
    type: Component,
    args: [{
      selector: 'wg-duration-input',
      standalone: false,
      template: "\n<div class=\"form-group form-inline\" *ngIf=\"form\" [formGroup]=\"form\">\n  <input\n    type=\"number\" \n    class=\"form-control\"\n    formControlName=\"time\">\n  <wg-dropdown\n    [dropdownList]=\"timeScales\"\n    formControlName=\"timeScale\">\n  </wg-dropdown>\n  <ng-content></ng-content>\n</div>  \n",
      styles: ["input[type=number]{min-width:0;width:120px;margin-right:5px}wg-dropdown{width:150px}\n"]
    }]
  }], () => [{
    type: i1$1.NgControl,
    decorators: [{
      type: Self
    }, {
      type: Optional
    }]
  }, {
    type: i1.TranslateService
  }, {
    type: i1$1.UntypedFormBuilder
  }], {
    scales: [{
      type: Input
    }]
  });
})();

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This library composes a collection of components
 * for datetimepicker
 *
 */
class WgDateTimePickerModule {
  static {
    this.ɵfac = function WgDateTimePickerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgDateTimePickerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgDateTimePickerModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, ReactiveFormsModule, SliderModule, TranslateModule, WgIconModule, WgServicesModule, WgDropdownModule, WgSelectButtonModule, WgSelectButtonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgDateTimePickerModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, ReactiveFormsModule, SliderModule, TranslateModule, WgIconModule, WgServicesModule, WgDropdownModule, WgSelectButtonModule],
      declarations: [DateInputComponent, DateTimePickerComponent, DayTimeRangeComponent, TimeInputComponent, DurationInputComponent, WgSliderComponent],
      exports: [DateInputComponent, DateTimePickerComponent, DayTimeRangeComponent, TimeInputComponent, DurationInputComponent, WgSliderComponent, WgSelectButtonModule]
    }]
  }], null, null);
})();

/*
 * Public API Surface of wg-datetimepicker
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CALENDAR_PRESETS, DateInputComponent, DateTimePickerComponent, DayTimeRangeComponent, DurationInputComponent, SLIDER_VALUE_ACCESSOR, TimeInputComponent, WgDateTimePickerModule, WgSliderComponent };
